import { IconTypes } from "./components/Icons/Icon";
import { ResourceTableHeader } from "./components/Resource/ResourceTable";

export enum Locale {
  EN = "en",
  NL = "nl",
  FR = "fr",
  DE = "de",
}

export enum PublicLocale {
  // i18n.t('PublicLocale::af')
  AF = "af",
  // i18n.t('PublicLocale::am')
  AM = "am",
  // i18n.t('PublicLocale::ar')
  AR = "ar",
  // i18n.t('PublicLocale::arn')
  ARN = "arn",
  // i18n.t('PublicLocale::as')
  AS = "as",
  // i18n.t('PublicLocale::az')
  AZ = "az",
  // i18n.t('PublicLocale::ba')
  BA = "ba",
  // i18n.t('PublicLocale::be')
  BE = "be",
  // i18n.t('PublicLocale::bg')
  BG = "bg",
  // i18n.t('PublicLocale::bn')
  BN = "bn",
  // i18n.t('PublicLocale::bo')
  BO = "bo",
  // i18n.t('PublicLocale::br')
  BR = "br",
  // i18n.t('PublicLocale::bs')
  BS = "bs",
  // i18n.t('PublicLocale::ca')
  CA = "ca",
  // i18n.t('PublicLocale::co')
  CO = "co",
  // i18n.t('PublicLocale::cs')
  CS = "cs",
  // i18n.t('PublicLocale::cy')
  CY = "cy",
  // i18n.t('PublicLocale::da')
  DA = "da",
  // i18n.t('PublicLocale::de')
  DE = "de",
  // i18n.t('PublicLocale::dsb')
  DSB = "dsb",
  // i18n.t('PublicLocale::dv')
  DV = "dv",
  // i18n.t('PublicLocale::el')
  EL = "el",
  // i18n.t('PublicLocale::en')
  EN = "en",
  // i18n.t('PublicLocale::es')
  ES = "es",
  // i18n.t('PublicLocale::et')
  ET = "et",
  // i18n.t('PublicLocale::eu')
  EU = "eu",
  // i18n.t('PublicLocale::fa')
  FA = "fa",
  // i18n.t('PublicLocale::fi')
  FI = "fi",
  // i18n.t('PublicLocale::fil')
  FIL = "fil",
  // i18n.t('PublicLocale::fo')
  FO = "fo",
  // i18n.t('PublicLocale::fr')
  FR = "fr",
  // i18n.t('PublicLocale::fy')
  FY = "fy",
  // i18n.t('PublicLocale::ga')
  GA = "ga",
  // i18n.t('PublicLocale::gd')
  GD = "gd",
  // i18n.t('PublicLocale::gl')
  GL = "gl",
  // i18n.t('PublicLocale::gsw')
  GSW = "gsw",
  // i18n.t('PublicLocale::gu')
  GU = "gu",
  // i18n.t('PublicLocale::ha')
  HA = "ha",
  // i18n.t('PublicLocale::he')
  HE = "he",
  // i18n.t('PublicLocale::hi')
  HI = "hi",
  // i18n.t('PublicLocale::hr')
  HR = "hr",
  // i18n.t('PublicLocale::hsb')
  HSB = "hsb",
  // i18n.t('PublicLocale::hu')
  HU = "hu",
  // i18n.t('PublicLocale::hy')
  HY = "hy",
  // i18n.t('PublicLocale::id')
  ID = "id",
  // i18n.t('PublicLocale::ig')
  IG = "ig",
  // i18n.t('PublicLocale::ii')
  II = "ii",
  // i18n.t('PublicLocale::in')
  IN = "in",
  // i18n.t('PublicLocale::is')
  IS = "is",
  // i18n.t('PublicLocale::it')
  IT = "it",
  // i18n.t('PublicLocale::iu')
  IU = "iu",
  // i18n.t('PublicLocale::iw')
  IW = "iw",
  // i18n.t('PublicLocale::ja')
  JA = "ja",
  // i18n.t('PublicLocale::ka')
  KA = "ka",
  // i18n.t('PublicLocale::kk')
  KK = "kk",
  // i18n.t('PublicLocale::kl')
  KL = "kl",
  // i18n.t('PublicLocale::km')
  KM = "km",
  // i18n.t('PublicLocale::kn')
  KN = "kn",
  // i18n.t('PublicLocale::kok')
  KOK = "kok",
  // i18n.t('PublicLocale::ko')
  KO = "ko",
  // i18n.t('PublicLocale::ky')
  KY = "ky",
  // i18n.t('PublicLocale::lb')
  LB = "lb",
  // i18n.t('PublicLocale::lo')
  LO = "lo",
  // i18n.t('PublicLocale::lt')
  LT = "lt",
  // i18n.t('PublicLocale::lv')
  LV = "lv",
  // i18n.t('PublicLocale::mi')
  MI = "mi",
  // i18n.t('PublicLocale::mk')
  MK = "mk",
  // i18n.t('PublicLocale::ml')
  ML = "ml",
  // i18n.t('PublicLocale::mn')
  MN = "mn",
  // i18n.t('PublicLocale::moh')
  MOH = "moh",
  // i18n.t('PublicLocale::mr')
  MR = "mr",
  // i18n.t('PublicLocale::ms')
  MS = "ms",
  // i18n.t('PublicLocale::mt')
  MT = "mt",
  // i18n.t('PublicLocale::nb')
  NB = "nb",
  // i18n.t('PublicLocale::ne')
  NE = "ne",
  // i18n.t('PublicLocale::nl')
  NL = "nl",
  // i18n.t('PublicLocale::nn')
  NN = "nn",
  // i18n.t('PublicLocale::no')
  NO = "no",
  // i18n.t('PublicLocale::nso')
  NSO = "nso",
  // i18n.t('PublicLocale::oc')
  OC = "oc",
  // i18n.t('PublicLocale::or')
  OR = "or",
  // i18n.t('PublicLocale::pa')
  PA = "pa",
  // i18n.t('PublicLocale::pl')
  PL = "pl",
  // i18n.t('PublicLocale::prs')
  PRS = "prs",
  // i18n.t('PublicLocale::ps')
  PS = "ps",
  // i18n.t('PublicLocale::pt')
  PT = "pt",
  // i18n.t('PublicLocale::qut')
  QUT = "qut",
  // i18n.t('PublicLocale::quz')
  QUZ = "quz",
  // i18n.t('PublicLocale::rm')
  RM = "rm",
  // i18n.t('PublicLocale::ro')
  RO = "ro",
  // i18n.t('PublicLocale::ru')
  RU = "ru",
  // i18n.t('PublicLocale::rw')
  RW = "rw",
  // i18n.t('PublicLocale::sah')
  SAH = "sah",
  // i18n.t('PublicLocale::sa')
  SA = "sa",
  // i18n.t('PublicLocale::se')
  SE = "se",
  // i18n.t('PublicLocale::si')
  SI = "si",
  // i18n.t('PublicLocale::sk')
  SK = "sk",
  // i18n.t('PublicLocale::sl')
  SL = "sl",
  // i18n.t('PublicLocale::sma')
  SMA = "sma",
  // i18n.t('PublicLocale::smj')
  SMJ = "smj",
  // i18n.t('PublicLocale::smn')
  SMN = "smn",
  // i18n.t('PublicLocale::sms')
  SMS = "sms",
  // i18n.t('PublicLocale::sq')
  SQ = "sq",
  // i18n.t('PublicLocale::sr')
  SR = "sr",
  // i18n.t('PublicLocale::sv')
  SV = "sv",
  // i18n.t('PublicLocale::sw')
  SW = "sw",
  // i18n.t('PublicLocale::syr')
  SYR = "syr",
  // i18n.t('PublicLocale::ta')
  TA = "ta",
  // i18n.t('PublicLocale::te')
  TE = "te",
  // i18n.t('PublicLocale::tg')
  TG = "tg",
  // i18n.t('PublicLocale::th')
  TH = "th",
  // i18n.t('PublicLocale::tk')
  TK = "tk",
  // i18n.t('PublicLocale::tlh')
  TLH = "tlh",
  // i18n.t('PublicLocale::tn')
  TN = "tn",
  // i18n.t('PublicLocale::tr')
  TR = "tr",
  // i18n.t('PublicLocale::tt')
  TT = "tt",
  // i18n.t('PublicLocale::tzm')
  TZM = "tzm",
  // i18n.t('PublicLocale::ug')
  UG = "ug",
  // i18n.t('PublicLocale::uk')
  UK = "uk",
  // i18n.t('PublicLocale::ur')
  UR = "ur",
  // i18n.t('PublicLocale::uz')
  UZ = "uz",
  // i18n.t('PublicLocale::vi')
  VI = "vi",
  // i18n.t('PublicLocale::wo')
  WO = "wo",
  // i18n.t('PublicLocale::xh')
  XH = "xh",
  // i18n.t('PublicLocale::yo')
  YO = "yo",
  // i18n.t('PublicLocale::zh')
  ZH = "zh",
  // i18n.t('PublicLocale::zu')
  ZU = "zu",
}

export interface Me {
  name?: string;
  email?: string;
  locale?: Locale;
  avatar_url?: string;
  avatar?: any;
  workspace_id?: string;
}

export interface User {
  id: string;
  name: string;
  email: string;
  avatar_url?: string;
  otp_enabled: boolean;
  workspace?: Workspace;
  email_confirmed_at: string;
  created_at: string;
  locale: Locale;
  user_workspace_setting?: UserWorkspaceSetting;
}

export enum UserWorkspaceSettingStatus {
  // i18n.t('UserWorkspaceSettingStatus::active')
  ACTIVE = "active",
  // i18n.t('UserWorkspaceSettingStatus::invited')
  INVITED = "invited",
}

export enum UserWorkspaceSettingRole {
  // i18n.t('UserWorkspaceSettingRole::owner')
  OWNER = "owner",
  // i18n.t('UserWorkspaceSettingRole::manager')
  MANAGER = "manager",
  // i18n.t('UserWorkspaceSettingRole::employee')
  EMPLOYEE = "employee",
}

export enum UserWorkspaceSettingScope {
  DASHBOARD = "dashboard",
  CALENDAR = "calendar",
  BOOKING = "booking",
  TASK = "task",
  CONTACT = "contact",
  DEAL = "deal",
  PROJECT = "project",
  TIME_TRACKING = "time_tracking",
  TIME_TRACKING_EXPORT = "time_tracking:export",
  PROPOSAL = "proposal",
  CONTRACT = "contract",
  INVOICE = "invoice",
  INVOICE_EXPORT = "invoice:export",
  EXPENSE = "expense",
  EXPENSE_EXPORT = "expense:export",
  DOCUMENT = "document",
  DOCUMENT_EXPORT = "document:export",
  BANK = "bank",
  BANK_PAYMENT = "bank:payment",
  ACCOUNTANT = "accountant",
  PRODUCT = "product",
  PRODUCT_EXPORT = "product:export",
  PRODUCT_VIEW_PURCHASE_PRICE = "product:view_purchase_price",
  REPORTING = "reporting",
  SETTING = "setting",
  FILE = "file",
  FORM = "form",
  PLAYBOOK = "playbook",
  SEQUENCE = "sequence",
  INBOX = "inbox",
  HELP_CENTER = "help_center",
  NEWS_CENTER = "news_center",
  WIDGET = "widget",
}

// t('WeekdaySchedule::0')
// t('WeekdaySchedule::1')
// t('WeekdaySchedule::2')
// t('WeekdaySchedule::3')
// t('WeekdaySchedule::4')
// t('WeekdaySchedule::5')
// t('WeekdaySchedule::6')
export interface WeekdaySchedule {
  enabled?: boolean;
  start_time?: string;
  end_time?: string;
  break_enabled?: boolean;
  break_start_time?: string;
  break_end_time?: string;
}

export interface DashboardLayoutItem {
  i: string;
  type: string;
  x: number;
  y: number;
  w: number;
  h: number;
}

export interface DashboardLayout {
  version: number;
  items: DashboardLayoutItem[];
}

export interface DashboardOverdueInvoice {
  id: string;
  number: string;
  contact_name: string | null;
  currency: string;
  due_on: string;
  days_overdue: number;
  open_amount: string;
  reminders_count: number;
  last_reminder_sent_at: string | null;
}

export interface DashboardOverdueInvoices {
  currency: string;
  total: string;
  count: number;
  invoices: DashboardOverdueInvoice[];
}

export type DashboardRecurringInvoiceDelivery = "peppol" | "email" | "manual";

export interface DashboardUpcomingRecurringInvoice {
  id: string;
  date: string;
  contact_name: string | null;
  currency: string;
  amount: string;
  recurrence_unit: RecurrenceUnit;
  delivery: DashboardRecurringInvoiceDelivery;
}

export interface DashboardUpcomingRecurringInvoices {
  currency: string;
  days: number;
  total: string;
  count: number;
  invoices: DashboardUpcomingRecurringInvoice[];
}

export type DashboardExpenseSource = "peppol" | "upload" | "manual";

export interface DashboardExpenseToProcess {
  id: string;
  name: string;
  supplier_name: string | null;
  currency: string;
  amount: string;
  invoiced_on: string;
  received_at: string;
  source: DashboardExpenseSource;
}

export interface DashboardExpensesToProcess {
  currency: string;
  total: string;
  count: number;
  peppol_count: number;
  upload_count: number;
  expenses: DashboardExpenseToProcess[];
}

export type DashboardProjectBudgetHealthStatus = "healthy" | "near_budget" | "over_budget";

export interface DashboardProjectBudget {
  id: string;
  name: string;
  contact_name: string | null;
  budget_type: ProjectBudgetType.TOTAL_COSTS | ProjectBudgetType.TOTAL_HOURS;
  budget: string;
  used: string;
  remaining: string;
  used_ratio: string;
  warning_threshold: string;
  resets_monthly: boolean;
  health: DashboardProjectBudgetHealthStatus;
}

export interface DashboardProjectBudgetHealth {
  currency: string;
  count: number;
  over_budget_count: number;
  near_budget_count: number;
  projects: DashboardProjectBudget[];
}

export interface DashboardUnbilledTimeEntriesClient {
  /** null groups the time entries without a client */
  contact_id: string | null;
  name: string | null;
  color: string | null;
  total: string;
  hours: string;
}

export interface DashboardUnbilledTimeEntries {
  currency: string;
  total: string;
  hours: string;
  clients: DashboardUnbilledTimeEntriesClient[];
}

export interface UserWorkspaceSetting {
  id?: string;
  email?: string;
  role?: UserWorkspaceSettingRole;
  scopes?: UserWorkspaceSettingScope[];
  hourly_cost?: number;
  hourly_rate?: number;
  day_rate?: number;
  status?: UserWorkspaceSettingStatus;
  admin?: boolean;
  week_schedule?: WeekdaySchedule[];
  user?: User;
  user_id?: string;
  workspace?: Workspace;
  workspace_id?: string;
  dashboard_layout?: DashboardLayout | null;
}

export interface CurrentUser extends User {}

export enum PeppolWorkspaceStatus {
  APPROVED = "approved",
  PENDING = "pending",
  REJECTED = "rejected",
}

export interface Workspace {
  id: string;
  business_name: string;
  email: string;
  timezone: string;
  street: string;
  receipt_details: string;
  stripe_id: string;
  vip: boolean;
  slug: string;
  city: string;
  province: string;
  zip_code: string;
  country_code: string;
  vat_number: string;
  phone_number: string;
  bic_code?: string;
  account_number: string;
  website: string;
  appointment_url: string;
  description: string;
  did_onboarding: boolean;
  setting: Settings;
  subscription: Subscription;
  card: Card;
  users_count: number;
  business_logo_url: string | null;
  business_logo: string | null;
  app_invite_url: string | null;
  expense_email_address: string;
  bcc_email_address: string;
  peppol_id: string;
  peppol_status: PeppolWorkspaceStatus;
  peppol_enabled: boolean;
  peppol_identifiers?: PeppolIdentifier[];
}

export interface PeppolIdentifier {
  id?: string;
  scheme?: string;
  endpoint_id?: string;
  peppol_id?: string;
}

export enum NumberFormat {
  COMMA_PERIOD = "comma_period",
  PERIOD_COMMA = "period_comma",
  APOSTROPHE_PERIOD = "apostrophe_period",
  SPACE_COMMA = "space_comma",
  SPACE_PERIOD = "space_period",
}

export interface Settings {
  id: string;
  date_format: string;
  time_format: "hh:mm:ss" | "hh mm ss";
  hour_format: "24" | "12";
  start_week_on: "sunday" | "monday";
  default_ledger_item_locale: Locale;
  default_currency: string;
  number_format: NumberFormat;
  quotation_validity_duration: number;
  invoice_payment_duration: number;
  default_hourly_rate: number;
  default_day_rate: number;
  travel_cost: number;

  workspace_id: string;
  weekly_summary_subscription: boolean;
  invoice_viewed_subscription: boolean;
  invoices_due_today_subscription: boolean;
  default_ledger_condition_id: string;
  ledger_item_template_id: string;

  order_forms_enabled: boolean;
  prefix_order_form_number: string;
  order_form_number: string;
  suffix_order_form_number: string;
  next_order_form_number: string;
  order_form_validity_duration: number;

  delivery_notes_enabled: boolean;
  prefix_delivery_note_number: string;
  delivery_note_number: string;
  suffix_delivery_note_number: string;
  next_delivery_note_number: string;

  prefix_quotation_number: string;
  quotation_number: string;
  suffix_quotation_number: string;
  next_quotation_number: string;

  pro_forma_invoices_enabled?: boolean;
  prefix_pro_forma_invoice_number: string;
  pro_forma_invoice_number: string;
  suffix_pro_forma_invoice_number: string;
  next_pro_forma_invoice_number: string;

  prefix_invoice_number: string;
  invoice_number: string;
  suffix_invoice_number: string;
  next_invoice_number: string;

  billable_rounding: BillableRounding;
  default_identifier_type: RemittanceInformationType;
  yearly_revenue_goal?: string;
  invoice_reminders_enabled: boolean;
  invoice_reminders_interval: number;
  invoice_reminders_limit: number;
  invoice_paid_confirmation_enabled?: boolean;
  default_menu: NavigationMenuItem[];
  po_number_enabled?: boolean;
  default_rate_type?: RateType;
  translations: MobilityTranslations<SettingTranslateableFields>;
  auto_email_bcc_enabled?: boolean;
  bcc_email_addresses?: string[];
  approved_email_addresses?: string[];
  company_brand_color?: string;
  ledger_item_subject_enabled?: boolean;
  incoming_self_billing_orders_enabled?: boolean;
  prefix_deal_number: string;
  deal_number: string;
  suffix_deal_number: string;
  next_deal_number: string;
}

export type MobilityTranslations<T> = { [Property in Locale]?: T };

export type SettingTranslateableFields = {
  default_pro_forma_invoice_details?: string;
  pro_forma_invoice_email_subject?: string;
  pro_forma_invoice_email_body?: string;
  default_invoice_details?: string;
  invoice_email_subject?: string;
  invoice_email_body?: string;
  quotation_email_subject?: string;
  quotation_email_body?: string;
  default_quotation_details?: string;
  credit_note_email_subject?: string;
  credit_note_email_body?: string;
  default_credit_note_details?: string;
  invoice_reminder_email_subject?: string;
  invoice_reminder_email_body?: string;
  invoice_paid_email_subject?: string;
  invoice_paid_email_body?: string;
  order_form_email_subject?: string;
  order_form_email_body?: string;
  default_order_form_details?: string;
  default_delivery_note_details?: string;
  delivery_note_email_subject?: string;
  delivery_note_email_body?: string;
  contract_email_subject?: string;
  contract_email_body?: string;
  proposal_email_subject?: string;
  proposal_email_body?: string;
};

export enum BillableRounding {
  NONE = "none",
  ROUND_NEAREST_MINUTE = "round_nearest_minute",
  ROUND_NEAREST_QUARTER_HOUR = "round_nearest_quarter_hour",
  ROUND_NEAREST_HALF_HOUR = "round_nearest_half_hour",
  ROUND_NEAREST_HOUR = "round_nearest_hour",
}

export enum SubscriptionStatus {
  TRIALING = "trialing",
  ACTIVE = "active",
  UNPAID = "unpaid",
}
export interface Subscription {
  id: string;
  workspace_id: string;
  plan_id: string;
  status: SubscriptionStatus;
  stripe_id: string;
  trial_end: number;
  plan?: Plan;
}

export interface Card {
  id: string;
  brand: string;
  expires_on: string;
  last_digits: string;
  stripe_id: string;
}

export enum PlanType {
  FREE = "free",
  BUSINESS = "business",
  BUSINESS_PRO = "business_pro",
}

export interface Plan {
  id: string;
  name: string;
  type: PlanType;
  stripe_id: string;
  price: number;
  interval: number;
}

export interface SubscriptionInterval {
  name: string;
  value: number;
}

export interface RequestErrors {
  errors: any;
}

export enum ExpenseType {
  // t('ExpenseType::invoice')
  INVOICE = "invoice",
  // t('ExpenseType::credit_note')
  CREDIT_NOTE = "credit_note",
}

export enum ExpenseStatus {
  // t('ExpenseStatus::overdue')
  OVERDUE = "overdue",
  // t('ExpenseStatus::outstanding')
  OUTSTANDING = "outstanding",
  // t('ExpenseStatus::paid')
  PAID = "paid",
}

export interface Expense {
  // i18n.t('Expense::id')
  id?: string;
  // i18n.t('Expense::color')
  color?: string;
  // i18n.t('Expense::name')
  name?: string;
  // i18n.t('Expense::type')
  type?: ExpenseType;
  // i18n.t('Expense::notes')
  notes?: string;
  // i18n.t('Expense::invoiced_on')
  invoiced_on?: string | any;
  // i18n.t('Expense::due_on')
  due_on?: string | any;
  // i18n.t('Expense::paid_on')
  paid_on?: string | any;
  // i18n.t('Expense::net_total')
  net_total?: string | number;
  // i18n.t('Expense::amount')
  amount?: string | number;
  // i18n.t('Expense::billable')
  billable?: boolean;
  // i18n.t('Expense::markup')
  markup?: string | number;
  // i18n.t('Expense::billable_amount')
  billable_amount?: string | number;
  // i18n.t('Expense::billed')
  billed?: boolean;
  attachment_file_name?: string;
  attachment_content_type?: string;
  attachment_file_size?: number;
  attachment_url?: string | null;
  attachment_download_url?: string | null;
  attachment?: any;
  supplier_id?: string;
  // i18n.t('Expense::supplier')
  supplier?: Contact;
  category_id?: string;
  // i18n.t('Expense::category')
  category?: ExpenseCategory;
  // i18n.t('Expense::currency')
  currency?: string;
  // i18n.t('Expense::booked_on')
  booked_on?: string | Date | null | any;
  contact_id?: string;
  // i18n.t('Expense::contact')
  contact?: Contact;
  project_id?: string;
  // i18n.t('Expense::project')
  project?: Project;
  ledger_item?: LedgerItem;
  ledger_item_id?: string;
  custom_fields?: ModelCustomFieldsType;
  recurring_schedule?: RecurringSchedule;
  payment_id?: string;
  payment?: Payment;
  remittance_information?: string;
  remittance_information_type?: RemittanceInformationType;
  // i18n.t('Expense::peppol_id')
  peppol_id?: string;
  // i18n.t('Expense::created_at')
  created_at?: string;
  // i18n.t('Expense::reviewed')
  reviewed?: boolean;
  extraction_data?: ExpenseExtractionData;
}

export type ExpenseProperty = keyof Expense;

export type ExpenseColumnProperty =
  | keyof Pick<
      Expense,
      | "id"
      | "color"
      | "name"
      | "type"
      | "notes"
      | "invoiced_on"
      | "due_on"
      | "paid_on"
      | "net_total"
      | "amount"
      | "billable"
      | "markup"
      | "billable_amount"
      | "billed"
      | "supplier"
      | "category"
      | "currency"
      | "booked_on"
      | "contact"
      | "project"
      | "remittance_information"
      | "peppol_id"
      | "created_at"
      | "reviewed"
    >
  | "attachment"
  | "status";

export const ExpenseColumns: ExpenseColumnProperty[] = [
  "id",
  "color",
  "name",
  "type",
  "attachment",
  "status",
  "notes",
  "invoiced_on",
  "due_on",
  "paid_on",
  "net_total",
  "amount",
  "billable",
  "markup",
  "billable_amount",
  "billed",
  "supplier",
  "category",
  "currency",
  "booked_on",
  "contact",
  "project",
  "remittance_information",
  "peppol_id",
  "created_at",
  "reviewed",
];

export type ExpenseFilterProperty = keyof Pick<
  Expense & { status?: ExpenseStatus; recurring?: boolean },
  | "name"
  | "status"
  | "invoiced_on"
  | "due_on"
  | "net_total"
  | "amount"
  | "currency"
  | "contact_id"
  | "project_id"
  | "supplier_id"
  | "recurring"
  | "booked_on"
  | "paid_on"
  | "billable"
  | "billed"
  | "created_at"
  | "category_id"
>;

export const ExpenseFilters: ExpenseFilterProperty[] = [
  "name",
  "status",
  "invoiced_on",
  "due_on",
  "net_total",
  "amount",
  "currency",
  "contact_id",
  "project_id",
  "supplier_id",
  "recurring",
  "booked_on",
  "paid_on",
  "billable",
  "billed",
  "created_at",
  "category_id",
];
export type ExpenseFilter = ResourceFilter<ExpenseFilterProperty>;

export interface ExpenseMetadata {
  previous_supplier_expense?: Expense;
}

export enum RemittanceInformationType {
  FREE = "free",
  UNSTRUCTURED = "unstructured",
  STRUCTURED = "structured",
}

export enum LedgerItemStatus {
  // t('LedgerItemStatus::draft')
  DRAFT = "draft",
  // t('LedgerItemStatus::overdue')
  OVERDUE = "overdue",
  // t('LedgerItemStatus::approved')
  APPROVED = "approved",
  // t('LedgerItemStatus::rejected')
  REJECTED = "rejected",
  // t('LedgerItemStatus::invoiced')
  INVOICED = "invoiced",
  // t('LedgerItemStatus::outstanding')
  OUTSTANDING = "outstanding",
  // t('LedgerItemStatus::paid')
  PAID = "paid",
  // t('LedgerItemStatus::delivered')
  DELIVERED = "delivered",
  // t('LedgerItemStatus::cancelled')
  CANCELLED = "cancelled",
  // t('LedgerItemStatus::expired')
  EXPIRED = "expired",
  // t('LedgerItemStatus::credited')
  CREDITED = "credited",
  // t('LedgerItemStatus::scheduled')
  SCHEDULED = "scheduled",
}

export interface LedgerItem {
  // i18n.t('LedgerItem::id')
  id?: string;
  contact_id?: string;
  // i18n.t('LedgerItem::contact')
  contact?: Contact;
  // i18n.t('LedgerItem::project')
  project?: Project;
  project_id?: string | null;
  email_contact_id?: string;
  email_contact?: Contact;
  // i18n.t('LedgerItem::created_at')
  created_at?: string;
  // i18n.t('LedgerItem::currency')
  currency?: string;
  details?: string;
  vat_rules?: string;
  // i18n.t('LedgerItem::due_on')
  due_on?: string | Date | any;
  // i18n.t('LedgerItem::approved_on')
  approved_on?: string | Date | any;
  // i18n.t('LedgerItem::rejected_on')
  rejected_on?: string | Date | any;
  estimated_net_on?: string | number;
  // i18n.t('LedgerItem::identifier')
  identifier?: string;
  identifier_type?: RemittanceInformationType;
  // i18n.t('LedgerItem::issued_on')
  issued_on?: string | Date | any;
  ledger_condition?: LedgerCondition;
  ledger_condition_id?: string;
  line_items?: LineItem[];
  // i18n.t('LedgerItem::notes')
  notes?: string;
  // i18n.t('LedgerItem::number')
  number?: string;
  // i18n.t('LedgerItem::subject')
  subject?: string;
  // i18n.t('LedgerItem::paid_on')
  paid_on?: string | Date | any;
  payment_gateway?: string | null;
  payment_id?: string | null;
  // i18n.t('LedgerItem::sent_at')
  sent_at?: string | Date | null;
  // i18n.t('LedgerItem::subtotal')
  subtotal?: string | number;
  // i18n.t('LedgerItem::discount')
  discount?: string | number;
  discount_total?: string | number;
  // i18n.t('LedgerItem::net_total')
  net_total?: string | number;
  // i18n.t('LedgerItem::tax_total')
  tax_total?: string | number;
  // i18n.t('LedgerItem::amount')
  amount?: string;
  type?: LedgerItemType;
  workspace_id?: string;
  // i18n.t('LedgerItem::viewed_at')
  viewed_at?: string | Date | any;
  // i18n.t('LedgerItem::updated_at')
  updated_at?: string | Date | any;
  // i18n.t('LedgerItem::booked_on')
  booked_on?: string | Date | null | any;
  // i18n.t('LedgerItem::invoiced_on')
  // Used to indicate when the quotation was invoiced
  invoiced_on?: string | Date | null | any;
  // Used to link a pro forma invoice to an invoice
  pro_forma_invoice_id?: string | null;
  // Use to link a creditnote to an invoice
  invoice_id?: string | null;
  // i18n.t('LedgerItem::credited_on')
  // Used to indicate when the invoice was credited
  credited_on?: string | Date | any;
  // Use to link a invoice to an quote
  quotation_id?: string | null;
  // i18n.t('LedgerItem::delivered_on')
  // Used to indicate when the order form has an attached delivery note
  delivered_on?: string | Date | null | any;
  // Used to indicate what delivery note is attached to an order form
  order_form_id?: string | null;
  // Used to indicate what invoice is attached to a delivery note
  delivery_note_id?: string | null;
  // i18n.t('LedgerItem::po_number')
  // Used to add a purchase order number
  po_number?: string | null;
  // i18n.t('LedgerItem::cancelled_on')
  cancelled_on?: string | Date | null | any;
  // i18n.t('LedgerItem::reminders_enabled')
  reminders_enabled?: boolean;
  // i18n.t('LedgerItem::next_occurence_on')
  reminders_count?: number;
  // i18n.t('LedgerItem::schedule')
  last_reminder_sent_at?: string | Date | null;
  recurring_schedule?: RecurringSchedule;
  recurring_auto_send?: boolean;
  custom_fields?: ModelCustomFieldsType;
  claim_id?: string;
  deal_id?: string;
  data?: LedgerItemData;
  peppol_id?: string;
  peppol_errors?: { field: string; value: string }[];
  pdf_attachment_file_name?: string;
  pdf_attachment_content_type?: string;
  pdf_attachment_file_size?: number;
  pdf_attachment_url?: string | null;
  pdf_attachment_download_url?: string | null;
}

export type LedgerItemProperty = keyof LedgerItem;

export type QuotationColumnProperty = keyof Pick<
  LedgerItem,
  | "id"
  | "number"
  | "contact"
  | "project"
  | "subject"
  | "identifier"
  | "po_number"
  | "currency"
  | "issued_on"
  | "due_on"
  | "invoiced_on"
  | "sent_at"
  | "viewed_at"
  | "subtotal"
  | "discount"
  | "net_total"
  | "tax_total"
  | "amount"
  | "notes"
  | "reminders_enabled"
  | "created_at"
  | "updated_at"
>;

export const QuotationColumns: QuotationColumnProperty[] = [
  "id",
  "contact",
  "project",
  "number",
  "subject",
  "identifier",
  "po_number",
  "currency",
  "issued_on",
  "due_on",
  "invoiced_on",
  "sent_at",
  "viewed_at",
  "subtotal",
  "discount",
  "net_total",
  "tax_total",
  "amount",
  "notes",
  "reminders_enabled",
  "created_at",
  "updated_at",
];

export type InvoiceColumnProperty =
  | keyof Pick<
      LedgerItem,
      | "id"
      | "number"
      | "contact"
      | "project"
      | "subject"
      | "identifier"
      | "po_number"
      | "currency"
      | "issued_on"
      | "due_on"
      | "paid_on"
      | "booked_on"
      | "credited_on"
      | "sent_at"
      | "viewed_at"
      | "subtotal"
      | "discount"
      | "net_total"
      | "tax_total"
      | "amount"
      | "notes"
      | "reminders_enabled"
      | "created_at"
      | "updated_at"
    >
  | "sent_peppol";

export const InvoiceColumns: InvoiceColumnProperty[] = [
  "id",
  "contact",
  "project",
  "number",
  "subject",
  "identifier",
  "po_number",
  "currency",
  "issued_on",
  "due_on",
  "paid_on",
  "booked_on",
  "credited_on",
  "sent_at",
  "sent_peppol",
  "viewed_at",
  "subtotal",
  "discount",
  "net_total",
  "tax_total",
  "amount",
  "notes",
  "reminders_enabled",
  "created_at",
  "updated_at",
];

export type CreditNoteColumnProperty =
  | keyof Pick<
      LedgerItem,
      | "id"
      | "number"
      | "contact"
      | "project"
      | "subject"
      | "identifier"
      | "po_number"
      | "currency"
      | "issued_on"
      | "due_on"
      | "paid_on"
      | "booked_on"
      | "credited_on"
      | "sent_at"
      | "viewed_at"
      | "subtotal"
      | "discount"
      | "net_total"
      | "tax_total"
      | "amount"
      | "notes"
      | "reminders_enabled"
      | "created_at"
      | "updated_at"
    >
  | "sent_peppol";

export const CreditNoteColumns: CreditNoteColumnProperty[] = [
  "id",
  "contact",
  "project",
  "number",
  "subject",
  "identifier",
  "po_number",
  "currency",
  "issued_on",
  "due_on",
  "paid_on",
  "booked_on",
  "credited_on",
  "sent_at",
  "sent_peppol",
  "viewed_at",
  "subtotal",
  "discount",
  "net_total",
  "tax_total",
  "amount",
  "notes",
  "reminders_enabled",
  "created_at",
  "updated_at",
];

export type RecurringInvoiceColumnProperty =
  | keyof Pick<
      LedgerItem,
      | "id"
      | "contact"
      | "project"
      | "subject"
      | "currency"
      | "subtotal"
      | "discount"
      | "net_total"
      | "tax_total"
      | "amount"
      | "notes"
      | "created_at"
      | "updated_at"
    >
  | "schedule"
  | "next_occurence_on"
  | "finish"
  | "auto_send";

export const RecurringInvoiceColumns: RecurringInvoiceColumnProperty[] = [
  "id",
  "contact",
  "project",
  "subject",
  "auto_send",
  "schedule",
  "next_occurence_on",
  "finish",
  "auto_send",
  "currency",
  "subtotal",
  "discount",
  "net_total",
  "tax_total",
  "amount",
  "notes",
  "created_at",
  "updated_at",
];

export type LedgerItemFilterProperty = keyof Pick<
  LedgerItem & { status: LedgerItemStatus },
  | "contact_id"
  | "project_id"
  | "status"
  | "number"
  | "po_number"
  | "identifier"
  | "net_total"
  | "amount"
  | "issued_on"
  | "due_on"
  | "credited_on"
  | "booked_on"
  | "invoiced_on"
  | "approved_on"
  | "rejected_on"
  | "delivered_on"
  | "reminders_enabled"
  | "recurring_auto_send"
  | "created_at"
>;

export const LedgerItemFilters: LedgerItemFilterProperty[] = [
  "contact_id",
  "project_id",
  "status",
  "number",
  "po_number",
  "identifier",
  "net_total",
  "amount",
  "issued_on",
  "due_on",
  "credited_on",
  "invoiced_on",
  "approved_on",
  "rejected_on",
  "delivered_on",
  "booked_on",
  "reminders_enabled",
  "recurring_auto_send",
  "created_at",
];
export type LedgerItemFilter = ResourceFilter<LedgerItemFilterProperty>;

export interface LedgerItemData {
  payment_confirmation_message?: string;
  payment_confirmation_attachments?: ActiveStorage.Blob[];
}

export enum RecurrenceUnit {
  DAILY = "daily",
  WEEKLY = "weekly",
  MONTHLY = "monthly",
  BIMONTHLY = "bimonthly",
  QUARTERLY = "quarterly",
  SEMESTERLY = "semesterly",
  YEARLY = "yearly",
}
export enum DayOfWeek {
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
  SUNDAY = 7,
}

export enum MonthOfYear {
  JANUARY = 1,
  FEBRUARY = 2,
  MARCH = 3,
  APRIL = 4,
  MAY = 5,
  JUNE = 6,
  JULY = 7,
  AUGUST = 8,
  SEPTEMBER = 9,
  OCTOBER = 10,
  NOVEMBER = 11,
  DECEMBER = 12,
}

export interface RecurringSchedule {
  start_date?: string | any;
  end_date?: string | any;
  recurrence_unit?: RecurrenceUnit | null;
  recurrence_interval?: number | null;
  repeat_on_day_of_week?: DayOfWeek[];
  repeat_on_day_of_month?: number | null;
  repeat_on_month_of_year?: MonthOfYear | null;
  timezone?: string;
  repeat_at_end_of_month?: boolean;
  schedulable_id?: string;
  schedulable_type?: string;
  next_occurrence_on?: string | Date | null | any;
}

export interface LedgerCondition {
  id?: string;
  name?: string;
  workspace_id?: string;
  translations: MobilityTranslations<LedgerConditionTranslateableFields>;
  created_at?: string;
  updated_at?: string;
}

export interface LedgerConditionTranslateableFields {
  content?: string;
}

export enum TimeEntryExportType {
  ALL = "all",
  BILLED = "billed",
  UNBILLED = "unbilled",
  BILLABLE = "billable",
  UNBILLABLE = "unbillable",
}

export interface TimeEntry {
  id?: string;
  description?: string;
  started_at?: string | Date;
  ended_at?: string | Date;
  duration?: number;
  base_rate?: number;
  cost_rate?: number;
  multiplier?: number;
  rate?: number;
  hours?: string | number;
  amount?: string | number;
  cost_total?: number;
  billable?: boolean;
  billed?: boolean;
  fixed_rate?: boolean;
  travel_distance?: number;
  active?: boolean;
  workspace_id?: string;
  user_id?: string;
  work_type_id?: string;
  contact_id?: string;
  project_id?: string;
  line_item_id?: string;
  task_id?: string;
  po_number?: string;
  work_type?: WorkType;
  deal_id?: string;
  contact?: Contact;
  project?: Project;
  custom_fields?: ModelCustomFieldsType;
  timer_action?: TimeEntryTimerAction;
}

export enum VATLiability {
  // t('VATLiability::unknown')
  UNKNOWN_VAT_LIABILITY = "unknown",
  // t('VATLiability::vat_liable')
  VAT_LIABLE_VAT_LIABILITY = "vat_liable",
  // t('VATLiability::intracommunity')
  INTRACOMMUNITY_VAT_LIABILITY = "intracommunity",
  // t('VATLiability::outside_eu')
  OUTSIDE_EU_VAT_LIABILITY = "outside_eu",
  // t('VATLiability::private_person')
  PRIVATE_PERSON_VAT_LIABILITY = "private_person",
  // t('VATLiability::exempted')
  EXEMPTED_VAT_LIABILITY = "exempted",
  // t('VATLiability::co_contractor')
  CO_CONTRACTOR_VAT_LIABILITY = "co_contractor",
}

export const enum ContactType {
  // t('ContactType::person')
  PERSON = "person",
  // t('ContactType::company')
  COMPANY = "company",
}
export interface Person extends ContactBase {
  type?: ContactType.PERSON;
  first_name?: string;
  last_name?: string;
  job_title?: string;
  birthdate?: string | Date;
}
export interface Company extends ContactBase {
  type?: ContactType.COMPANY;
  contacts_count?: number;
}

export type Contact = Person | Company;
export type ContactProperty = keyof Contact;

export type PersonColumnProperty = keyof Pick<
  Person,
  "first_name" | "last_name" | "job_title" | "birthdate"
>;

export type CompanyColumnProperty = keyof Pick<
  Company,
  | "name"
  | "type"
  | "background_info"
  | "alias"
  | "color"
  | "locale"
  | "currency"
  | "vat_number"
  | "notes"
  | "referral_source"
  | "hourly_rate"
  | "day_rate"
  | "archived"
  | "vat_liability"
  | "rate_type"
  | "peppol_id"
  | "emails"
  | "telephone_numbers"
  | "account_numbers"
  | "billing_address"
  | "delivery_address"
  | "websites"
  | "groups"
  | "starred"
  | "marketing_consent"
  | "created_at"
>;

export type ContactColumnProperty =
  | CompanyColumnProperty
  | PersonColumnProperty;

export const ContactColumns: ContactColumnProperty[] = [
  "name",
  "type",
  "background_info",
  "alias",
  "color",
  "locale",
  "currency",
  "vat_number",
  "notes",
  "referral_source",
  "hourly_rate",
  "day_rate",
  "archived",
  "vat_liability",
  "rate_type",
  "peppol_id",
  "emails",
  "telephone_numbers",
  "account_numbers",
  "billing_address",
  "delivery_address",
  "websites",
  "groups",
  "starred",
  "marketing_consent",
  "created_at",
];

export interface ContactColumnConfig extends ResourceColumnConfig {
  render: (options: { contact: Contact; setting: Settings }) => React.ReactNode;
}

export type ContactFilterProperty = keyof Pick<
  Contact,
  | "name"
  | "alias"
  | "type"
  | "group_ids"
  | "starred"
  | "archived"
  | "locale"
  | "vat_number"
  | "hourly_rate"
  | "day_rate"
  | "marketing_consent"
  | "created_at"
>;

export const ContactFilters: ContactFilterProperty[] = [
  "name",
  "alias",
  "type",
  "group_ids",
  "starred",
  "archived",
  "locale",
  "vat_number",
  "hourly_rate",
  "day_rate",
  "marketing_consent",
  "created_at",
];
export type ContactFilter = ResourceFilter<ContactFilterProperty>;

export interface ExportContactParams {
  export_type: SpreadsheetExportType;
}

export enum ContactEmailType {
  // t('ContactEmailType::work')
  WORK = "work",
  // t('ContactEmailType::personal')
  PERSONAL = "personal",
  // t('ContactEmailType::other')
  OTHER = "other",
}

export interface ContactEmail {
  id?: string;
  type?: ContactEmailType;
  value?: string;
  position?: number;
  _destroy?: boolean;
}

export enum ContactTelephoneNumberType {
  // t('ContactTelephoneNumberType::work')
  WORK = "work",
  // t('ContactTelephoneNumberType::mobile')
  MOBILE = "mobile",
  // t('ContactTelephoneNumberType::home')
  HOME = "home",
  // t('ContactTelephoneNumberType::fax')
  FAX = "fax",
  // t('ContactTelephoneNumberType::other')
  OTHER = "other",
}

export interface ContactTelephoneNumber {
  id?: string;
  type?: ContactTelephoneNumberType;
  value?: string;
  position?: number;
  _destroy?: boolean;
}

export interface ContactAccountNumber {
  id?: string;
  value?: string;
  position?: number;
  _destroy?: boolean;
}

export enum ContactAddressType {
  // t('ContactAddressType::billing')
  BILLING = "billing",
  // t('ContactAddressType::delivery')
  DELIVERY = "delivery",
}

export interface ContactAddress {
  id?: string;
  type?: ContactAddressType;
  street?: string;
  street_number?: string;
  city?: string;
  zip?: string;
  country?: string;
  state?: string;
  position?: number;
  _destroy?: boolean;
}

export interface ContactWebsite {
  id?: string;
  url?: string;
  position?: number;
  _destroy?: boolean;
}

export interface ContactBase {
  id?: string;
  name?: string;
  background_info?: string;
  alias?: string;
  color?: string;
  locale?: string;
  currency?: string;
  vat_number?: string;
  notes?: string;
  workspace_id?: string;
  referral_source_id?: string;
  referral_source?: ReferralSource;
  hourly_rate?: number;
  day_rate?: number;
  archived?: boolean;
  vat_liability?: VATLiability;
  rate_type?: RateType;
  peppol_id?: string;
  custom_fields?: ModelCustomFieldsType;
  emails?: ContactEmail[];
  telephone_numbers?: ContactTelephoneNumber[];
  account_numbers?: ContactAccountNumber[];
  billing_address?: ContactAddress;
  delivery_address?: ContactAddress;
  websites?: ContactWebsite[];
  contacts?: Contact[];
  groups?: ContactGroup[];
  group_ids?: string[];
  contact?: Contact;
  contact_id?: string;
  starred?: boolean;
  delivery_same_as_invoice_address?: boolean;
  marketing_consent?: boolean;
  created_at?: string | Date;
}

export interface ContactGroup {
  id?: string;
  name?: string;
  contact_count?: number;
  workspace_id?: string;
}

export enum ProjectStatus {
  ACTIVE = "active",
  PROPOSAL = "proposal",
  ON_HOLD = "on_hold",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
}

export enum ProjectBillableType {
  // t('ProjectBillableType::time_and_materials')
  TIME_AND_MATERIALS = "time_and_materials",
  // t('ProjectBillableType::fixed_budget')
  FIXED_BUDGET = "fixed_budget",
  // t('ProjectBillableType::non_billable')
  NON_BILLABLE = "non_billable",
}

export enum ProjectBudgetType {
  // t('ProjectBudgetType::none')
  NONE = "none",
  // t('ProjectBudgetType::total_costs')
  TOTAL_COSTS = "total_costs",
  // t('ProjectBudgetType::total_hours')
  TOTAL_HOURS = "total_hours",
}

interface BudgetDataCosts {
  type: ProjectBudgetType.TOTAL_COSTS;
  budget: number;
  budget_alert_treshold: number;
  remaining_budget: number;
  labour: number;
  expenses: number;
}

interface BudgetDataHours {
  type: ProjectBudgetType.TOTAL_HOURS;
  budget: number;
  budget_alert_treshold: number;
  remaining_budget: number;
  hours: number;
}

export type BudgetData = BudgetDataCosts | BudgetDataHours;

export interface ProjectTag {
  id?: string;
  name?: string;
  project_count?: number;
  workspace_id?: string;
}

export interface Project {
  // i18n.t('Project::id')
  id?: string;
  // i18n.t('Project::name')
  name?: string;
  // i18n.t('Project::code')
  code?: string;
  // i18n.t('Project::color')
  color?: string;
  // i18n.t('Project::notes')
  notes?: string;
  // i18n.t('Project::billable_type')
  billable_type?: ProjectBillableType;
  // i18n.t('Project::labour_costs')
  labour_costs?: number;
  // i18n.t('Project::budget_labour_costs')
  budget_labour_costs?: number;
  // i18n.t('Project::expense_costs')
  expense_costs?: number;
  // i18n.t('Project::budget_expense_costs')
  budget_expense_costs?: number;
  // i18n.t('Project::total_costs')
  total_costs?: number;
  // i18n.t('Project::budget_total_costs')
  budget_total_costs?: number;
  // i18n.t('Project::billable_hours')
  billable_hours?: number;
  // i18n.t('Project::budget_billable_hours')
  budget_billable_hours?: number;
  // i18n.t('Project::non_billable_hours')
  non_billable_hours?: number;
  // i18n.t('Project::budget_non_billable_hours')
  budget_non_billable_hours?: number;
  // i18n.t('Project::total_hours')
  total_hours?: number;
  // i18n.t('Project::budget_total_hours')
  budget_total_hours?: number;
  // i18n.t('Project::budget_type')
  budget_type?: ProjectBudgetType;
  // i18n.t('Project::budget')
  budget?: number;
  // i18n.t('Project::budget_hours')
  budget_hours?: number;
  // i18n.t('Project::budget_alert_treshold')
  budget_alert_treshold?: number;
  // i18n.t('Project::budget_spent')
  budget_spent?: number;
  // i18n.t('Project::budget_remaining')
  budget_remaining?: number;
  // i18n.t('Project::budget_alert_send_on')
  budget_alert_send_on?: string | Date;
  // i18n.t('Project::budget_resets_monthly')
  budget_resets_monthly?: boolean;
  // i18n.t('Project::hourly_rate')
  hourly_rate?: number;
  // i18n.t('Project::day_rate')
  day_rate?: number;
  // i18n.t('Project::estimated_start_date')
  estimated_start_date?: string;
  // i18n.t('Project::estimated_end_date')
  estimated_end_date?: string;
  // i18n.t('Project::start_date')
  start_date?: string;
  // i18n.t('Project::end_date')
  end_date?: string;
  // i18n.t('Project::cancel_date')
  cancel_date?: string;
  // i18n.t('Project::status')
  status?: ProjectStatus;
  contact_id?: string;
  workspace_id?: string;
  // i18n.t('Project::contact')
  contact?: Contact;
  // i18n.t('Project::archived')
  archived?: boolean;
  // i18n.t('Project::po_number')
  po_number?: string;
  // i18n.t('Project::rate_type')
  rate_type?: RateType;
  custom_fields?: ModelCustomFieldsType;
  // i18n.t('Project::tags')
  tags?: ProjectTag[];
  tag_ids?: string[];
  // i18n.t('Project::created_at')
  created_at?: string | Date;
}

export type ProjectProperty = keyof Project;

export type ProjectColumnProperty = keyof Pick<
  Project,
  | "id"
  | "name"
  | "code"
  | "po_number"
  | "contact"
  | "tags"
  | "color"
  | "notes"
  | "billable_type"
  | "labour_costs"
  | "budget_labour_costs"
  | "expense_costs"
  | "budget_expense_costs"
  | "total_costs"
  | "budget_total_costs"
  | "billable_hours"
  | "budget_billable_hours"
  | "non_billable_hours"
  | "budget_non_billable_hours"
  | "total_hours"
  | "budget_total_hours"
  | "budget_type"
  | "budget"
  | "budget_hours"
  | "budget_alert_treshold"
  | "budget_spent"
  | "budget_remaining"
  | "hourly_rate"
  | "day_rate"
  | "estimated_start_date"
  | "estimated_end_date"
  | "start_date"
  | "end_date"
  | "cancel_date"
  | "status"
  | "archived"
  | "rate_type"
  | "created_at"
>;

export const ProjectColumns: ProjectColumnProperty[] = [
  "id",
  "name",
  "code",
  "po_number",
  "contact",
  "tags",
  "color",
  "notes",
  "billable_type",
  "labour_costs",
  "budget_labour_costs",
  "expense_costs",
  "budget_expense_costs",
  "total_costs",
  "budget_total_costs",
  "billable_hours",
  "budget_billable_hours",
  "non_billable_hours",
  "budget_non_billable_hours",
  "total_hours",
  "budget_total_hours",
  "budget_type",
  "budget",
  "budget_hours",
  "budget_alert_treshold",
  "budget_spent",
  "budget_remaining",
  "hourly_rate",
  "day_rate",
  "estimated_start_date",
  "estimated_end_date",
  "start_date",
  "end_date",
  "cancel_date",
  "status",
  "archived",
  "rate_type",
  "created_at",
];

export type ProjectFilterProperty = keyof Pick<
  Project,
  | "name"
  | "code"
  | "tag_ids"
  | "po_number"
  | "contact_id"
  | "billable_type"
  | "hourly_rate"
  | "day_rate"
  | "budget"
  | "budget_type"
  | "total_costs"
  | "created_at"
>;

export const ProjectFilters: ProjectFilterProperty[] = [
  "name",
  "tag_ids",
  "po_number",
  "contact_id",
  "billable_type",
  "hourly_rate",
  "day_rate",
  "budget",
  "budget_type",
  "total_costs",
  "created_at",
];
export type ProjectFilter = ResourceFilter<ProjectFilterProperty>;

export interface ProjectSummary {
  hours: {
    total: number;
    billable: number;
    non_billable: number;
  };
  budget?: {
    type: ProjectBudgetType;
    total: number;
    used: number;
    remaining: number;
  };
  total_costs: {
    total: number;
    labour: number;
    expenses: number;
  };
  uninvoiced_amount: {
    total: number;
    project: number;
    labour_and_expenses: number;
  };
}

export enum ContactableType {
  CLIENT = "Contact",
  SUPPLIER = "Supplier",
  USER_WORKSPACE_SETTING = "UserWorkspaceSetting",
}

export enum IntegrationType {
  MOLLIE = "mollie",
  STRIPE = "stripe",
  YUKI = "yuki",
  CLEARFACTS = "clearfacts",
  PONTO = "ponto",
  PQR = "pqr",
  MAILCHIMP = "mailchimp",
  CONVERTKIT = "convertkit",
  MAILSYNC = "mailsync",
  UNPAID = "unpaid",
  OUTLOOK = "outlook",
  GMAIL = "gmail",
  OCTOPUS = "octopus",
}

export interface MarketplaceIntegration {
  id?: string;
  category?: string;
  active?: boolean;
  new?: boolean;
  image?: string;
  icon?: string;
  name?: string;
  title?: string;
  description?: string;
  connected?: boolean;
  theme?: {
    cover?: string;
    text?: string;
    button_text?: string;
    button_background?: string;
  };
}

export interface AccountingSyncIntegration {
  type: IntegrationType;
  name: string;
  icon: string;
  description: string;
  active: boolean;
}

export interface AccountingSyncStatus {
  last_accounting_sync_at: string | null;
  integrations: AccountingSyncIntegration[];
}

export interface Integration {
  id?: string;
  type?: IntegrationType;
  access_token?: string;
  refresh_token?: string;
  expires_at?: string;
  config?: IntegrationConfig;
}

export interface IntegrationConfig {}

export interface MollieIntegrationConfig extends IntegrationConfig {
  profile_id?: string;
}

export interface PontoIntegrationConfig extends IntegrationConfig {
  account_id?: string;
}

export interface YukiIntegrationConfig extends IntegrationConfig {
  access_token?: string;
  administration_id?: string;
}

export interface MailchimpIntegrationConfig extends IntegrationConfig {
  audience_id?: string;
  dc?: string;
}

export interface ClearfactsIntegrationConfig extends IntegrationConfig {
  company_number?: string;
}

export interface MailsyncIntegrationConfig extends IntegrationConfig {
  invoice_mailbox_address?: string;
  invoice_mailbox_subject?: string;
  expense_mailbox_address?: string;
  expense_mailbox_subject?: string;
  document_mailbox_address?: string;
  document_mailbox_subject?: string;
}

export interface UnpaidIntegrationConfig extends IntegrationConfig {
  company_name?: string;
  address?: string;
  zip_code?: string;
  location?: string;
  country_code?: string;
  vat_number?: string;
  iban?: string;
  bic?: string;
  contact_name?: string;
  email?: string;
  phone_number?: string;
}

export interface GmailIntegrationConfig extends IntegrationConfig {}
export interface GmailFormData {
  client_id: string;
  scopes: string[];
}

export interface OctopusIntegrationConfig extends IntegrationConfig {
  username?: string;
  password?: string;
  dossier_id?: string;
  invoice_mailbox_address?: string;
  expense_mailbox_address?: string;
  document_mailbox_address?: string;
}

export interface ConvertkitIntegrationConfig extends IntegrationConfig {
  api_key?: string;
  api_secret?: string;
  form_id?: string;
}

export interface ConvertkitFormData {
  forms: { id: string; name: string }[];
}

export interface IntegrationForm {
  type: IntegrationType;
  marketplace_integration: MarketplaceIntegration;
  integration: Integration;
  form_data: any;
}

export interface MollieFormData {
  profiles?: { label: string; value: string }[];
}

export interface PontoFormData {
  accounts?: { label: string; value: string }[];
}

export interface MailchimpFormData {
  audiences: { label: string; value: string }[];
}

export interface ClearfactsFormData {
  administrations: {
    name: string;
    company_number: string;
    emails: { type: string; email_address: string }[];
    company_type: string;
    address: {
      street_address: string;
    };
  }[];
}

export interface UnpaidFormData {
  countries?: { label: string; value: string }[];
}

export interface MailsyncFormData {
  smtp_configured: boolean;
}

export interface OutlookFormData {
  admin_consent_url?: string;
}

export interface OctopusFormData {
  dossiers?: { label: string; value: string }[];
}

export enum LineItemDiscountType {
  // t('LineItemDiscountType::percentage')
  PERCENTAGE = "percentage",
  // t('LineItemDiscountType::fixed')
  FIXED = "fixed",
}

export interface LineItem {
  id?: string;
  title?: string;
  description?: string;
  quantity?: number | string;
  price?: number | string;
  discount_type?: LineItemDiscountType;
  discount?: number | string;
  discount_total?: number | string;
  second_tax?: number | string;
  ledger_item_id?: string;
  tax_rate?: number | string;
  tax_code?: string;
  subtotal?: number | string;
  net_total?: number | string;
  tax_total?: number | string;
  total?: number | string;
  entry_ids?: string[];
  expense_ids?: string[];
  product_ids?: string[];
}

export type WorkspaceTaxTranslateableFields = {
  invoice_rule?: string;
  credit_note_rule?: string;
};

export interface WorkspaceTax {
  id?: string;
  code?: string;
  name?: string;
  rate?: number | string;
  translations?: MobilityTranslations<WorkspaceTaxTranslateableFields>;
  vat_liabilities?: VATLiability[];
}

export enum LedgerItemType {
  // t('LedgerItemType::order_form')
  ORDER_FORM = "order_form",
  // t('LedgerItemType::delivery_note')
  DELIVERY_NOTE = "delivery_note",
  // t('LedgerItemType::quotation')
  QUOTATION = "quotation",
  // t('LedgerItemType::pro_forma_invoice')
  PRO_FORMA_INVOICE = "pro_forma_invoice",
  // t('LedgerItemType::invoice')
  INVOICE = "invoice",
  // t('LedgerItemType::credit_note')
  CREDIT_NOTE = "credit_note",
  // t('LedgerItemType::recurring_invoice')
  RECURRING_INVOICE = "recurring_invoice",
  // t('LedgerItemType::incoming_self_billing_order')
  INCOMING_SELF_BILLING_ORDER = "incoming_self_billing_order",
}

export interface ImportedProduct {
  productId: string;
  quantity: number;
  product: Product;
}

export interface Product {
  // i18n.t('Product::id')
  id?: string;
  // i18n.t('Product::name')
  name?: string;
  // i18n.t('Product::notes')
  notes?: string;
  // i18n.t('Product::description')
  description?: string;
  // i18n.t('Product::purchase_price')
  purchase_price?: number | string;
  // i18n.t('Product::price')
  price?: number | string;
  // i18n.t('Product::gross_price')
  gross_price?: number | string;
  // i18n.t('Product::tax_rate')
  tax_rate?: number | string;
  // i18n.t('Product::tax_code')
  tax_code?: string;
  // i18n.t('Product::stock')
  stock?: number | string;
  // i18n.t('Product::minimum_stock')
  minimum_stock?: number | string;
  // i18n.t('Product::sku')
  sku?: string;
  // i18n.t('Product::barcode')
  barcode?: string;
  workspace_id?: string;
  supplier_id?: string;
  // i18n.t('Product::supplier')
  supplier?: Contact;
  // i18n.t('Product::physical')
  physical?: boolean;
  custom_fields?: ModelCustomFieldsType;
  // i18n.t('Product::created_at')
  created_at?: string | Date;
}

export type ProductProperty = keyof Product;

export type ProductColumnProperty = keyof Pick<
  Product,
  | "id"
  | "name"
  | "notes"
  | "description"
  | "purchase_price"
  | "price"
  | "gross_price"
  | "tax_rate"
  | "tax_code"
  | "stock"
  | "minimum_stock"
  | "sku"
  | "barcode"
  | "supplier"
  | "physical"
  | "created_at"
>;

export const ProductColumns: ProductColumnProperty[] = [
  "id",
  "name",
  "notes",
  "description",
  "purchase_price",
  "price",
  "gross_price",
  "tax_rate",
  "tax_code",
  "stock",
  "minimum_stock",
  "sku",
  "barcode",
  "supplier",
  "physical",
  "created_at",
];

export type ProductFilterProperty = keyof Pick<
  Product,
  | "name"
  | "price"
  | "purchase_price"
  | "gross_price"
  | "supplier_id"
  | "sku"
  | "barcode"
  | "stock"
  | "minimum_stock"
  | "physical"
  | "created_at"
>;

export const ProductFilters: ProductFilterProperty[] = [
  "name",
  "price",
  "purchase_price",
  "gross_price",
  "supplier_id",
  "sku",
  "barcode",
  "stock",
  "minimum_stock",
  "physical",
  "created_at",
];
export type ProductFilter = ResourceFilter<ProductFilterProperty>;

export interface Board {
  id?: string;
  name?: string;
  color?: string;
  archived?: boolean;
  contact_id?: string;
  contact?: Contact;
  project_id?: string;
  project?: Project;
  workspace_id?: string;
  lists?: BoardList[];
}

export interface BoardTemplate {
  id?: string;
  name?: string;
}

export interface BoardList {
  id?: string;
  name?: string;
  position?: number;
  board_id?: string;
}

export interface BoardListMetadata {
  positions: number[];
}

export interface BoardLabel {
  id?: string;
  name?: string;
  color?: string;
  board_id?: string;
}

export interface Task {
  id?: string;
  // i18n.t('Task::name')
  name?: string;
  // i18n.t('Task::description')
  description?: string;
  // i18n.t('Task::start_on')
  start_on?: string | null;
  // i18n.t('Task::due_on')
  due_on?: string | null;
  // i18n.t('Task::completed')
  completed?: boolean;
  position?: number;
  // i18n.t('Task::telephone_number')
  telephone_number?: string;
  // i18n.t('Task::location')
  location?: string;
  workspace_id?: string;
  board_id?: string;
  // i18n.t('Task::board')
  board?: Board;
  list_id?: string;
  // i18n.t('Task::list')
  list?: BoardList;
  cover_id?: string;
  deal_id?: string;
  cover?: BizzeyFile;
  // i18n.t('Task::labels')
  labels?: BoardLabel[];
  label_ids?: string[];
  checklists?: TaskChecklist[];
  attachments?: BizzeyFile[];
  custom_fields?: ModelCustomFieldsType;
  assignee_ids?: string[];
  // i18n.t('Task::assignees')
  assignees?: User[];
  contact_id?: string;
  // i18n.t('Task::contact')
  contact?: Contact;
  project_id?: string;
  // i18n.t('Task::project')
  project?: Project;
  playbook_id?: string;
  time_estimate?: number;
  time_planned?: number;
  time_remaining?: number;
  time_spent?: number;
  created_at?: string;
}

export type TaskProperty = keyof Task;

export type TaskColumnProperty =
  | keyof Pick<
      Task,
      | "id"
      | "name"
      | "labels"
      | "assignees"
      | "list"
      | "start_on"
      | "due_on"
      | "telephone_number"
      | "location"
      | "description"
      | "board"
      | "time_estimate"
      | "contact"
      | "project"
      | "created_at"
    >
  | "indicators";

export const TaskColumns: TaskColumnProperty[] = [
  "id",
  "name",
  "labels",
  "assignees",
  "list",
  "indicators",
  "start_on",
  "due_on",
  "telephone_number",
  "location",
  "description",
  "board",
  "time_estimate",
  "contact",
  "project",
  "created_at",
];

export interface TaskColumnConfig extends ResourceColumnConfig {
  header: (options: {
    onSortChange: (sortValue: string) => void;
    setting: Settings;
    sortValue: string;
  }) => ResourceTableHeader;
  render: (options: {
    task: Task;
    setting: Settings;
    onBoardClick: (task: Task) => void;
    onCompletedChange: (task: Task) => void;
    onSortChange: (sortValue: string) => void;
  }) => React.ReactNode;
}

export interface TaskChecklist {
  name?: string;
  position?: number;
  items?: TaskChecklistItem[];
}

export interface TaskChecklistItem {
  name?: string;
  completed?: boolean;
  position?: number;
}

export type NotificationType =
  | "ledger_item_opened"
  | "invoice_paid"
  | "subscription_payment_failed";

export enum WorkspaceEvents {
  UPDATE_TIMER = "UPDATE_TIMER",
}

export enum TimeEntryTimerAction {
  PAUSE = "pause",
  STOP = "stop",
}

export enum WorkspaceChannelEventType {
  WORKSPACE_CREATE = "WORKSPACE_CREATE",
  WORKSPACE_UPDATE = "WORKSPACE_UPDATE",
  WORKSPACE_DELETE = "WORKSPACE_DELETE",

  SUBSCRIPTION_CREATE = "SUBSCRIPTION_CREATE",
  SUBSCRIPTION_UPDATE = "SUBSCRIPTION_UPDATE",
  SUBSCRIPTION_DELETE = "SUBSCRIPTION_DELETE",

  SETTING_CREATE = "SETTING_CREATE",
  SETTING_UPDATE = "SETTING_UPDATE",
  SETTING_DELETE = "SETTING_DELETE",

  DEAL_STAGE_CREATE = "DEAL_STAGE_CREATE",
  DEAL_STAGE_UPDATE = "DEAL_STAGE_UPDATE",
  DEAL_STAGE_DELETE = "DEAL_STAGE_DELETE",

  DEAL_CREATE = "DEAL_CREATE",
  DEAL_UPDATE = "DEAL_UPDATE",
  DEAL_DELETE = "DEAL_DELETE",

  BOARD_CREATE = "BOARD_CREATE",
  BOARD_UPDATE = "BOARD_UPDATE",
  BOARD_DELETE = "BOARD_DELETE",

  BOARD_LABEL_CREATE = "BOARD_LABEL_CREATE",
  BOARD_LABEL_UPDATE = "BOARD_LABEL_UPDATE",
  BOARD_LABEL_DELETE = "BOARD_LABEL_DELETE",

  BOARD_LIST_CREATE = "BOARD_LIST_CREATE",
  BOARD_LIST_UPDATE = "BOARD_LIST_UPDATE",
  BOARD_LIST_DELETE = "BOARD_LIST_DELETE",

  TASK_CREATE = "TASK_CREATE",
  TASK_UPDATE = "TASK_UPDATE",
  TASK_DELETE = "TASK_DELETE",

  TIME_ENTRY_CREATE = "TIME_ENTRY_CREATE",
  TIME_ENTRY_UPDATE = "TIME_ENTRY_UPDATE",
  TIME_ENTRY_DELETE = "TIME_ENTRY_DELETE",

  LEDGER_ITEM_ATTACHMENTS_READY = "LEDGER_ITEM_ATTACHMENTS_READY",

  ACCOUNT_CREATE = "ACCOUNT_CREATE",
  ACCOUNT_UPDATE = "ACCOUNT_UPDATE",
  ACCOUNT_DELETE = "ACCOUNT_DELETE",

  TRANSACTION_CREATE = "TRANSACTION_CREATE",
  TRANSACTION_UPDATE = "TRANSACTION_UPDATE",
  TRANSACTION_DELETE = "TRANSACTION_DELETE",

  EXPENSE_CREATE = "EXPENSE_CREATE",
  EXPENSE_UPDATE = "EXPENSE_UPDATE",
  EXPENSE_DELETE = "EXPENSE_DELETE",

  CONVERSATION_CREATE = "CONVERSATION_CREATE",
  CONVERSATION_UPDATE = "CONVERSATION_UPDATE",
  CONVERSATION_DELETE = "CONVERSATION_DELETE",

  WIDGET_SESSION_CREATE = "WIDGET_SESSION_CREATE",
  WIDGET_SESSION_UPDATE = "WIDGET_SESSION_UPDATE",
  WIDGET_SESSION_DELETE = "WIDGET_SESSION_DELETE",

  CALL = "CALL",
}

export interface WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType;
  data: object;
}

export interface WorkspaceChannelCreateWorkspaceEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.WORKSPACE_CREATE;
  data: { workspace: Workspace };
}

export interface WorkspaceChannelUpdateWorkspaceEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.WORKSPACE_UPDATE;
  data: { workspace: Workspace };
}

export interface WorkspaceChannelDeleteWorkspaceEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.WORKSPACE_DELETE;
  data: { workspace_id: string };
}

export interface WorkspaceChannelCreateSubscriptionEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.SUBSCRIPTION_CREATE;
  data: { subscription: Subscription };
}

export interface WorkspaceChannelUpdateSubscriptionEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.SUBSCRIPTION_UPDATE;
  data: { subscription: Subscription };
}

export interface WorkspaceChannelDeleteSubscriptionEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.SUBSCRIPTION_DELETE;
  data: { workspace_id: string; subscription_id: string };
}

export interface WorkspaceChannelCreateSettingEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.SETTING_CREATE;
  data: { setting: Settings };
}

export interface WorkspaceChannelUpdateSettingEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.SETTING_UPDATE;
  data: { setting: Settings };
}

export interface WorkspaceChannelDeleteSettingEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.SETTING_DELETE;
  data: { setting_id: string };
}

export interface WorkspaceChannelCallEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.CALL;
  data: { telephone_number: string; user_id: string };
}

export interface WorkspaceChannelCreateDealStageEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.DEAL_STAGE_CREATE;
  data: { deal_stage: DealStage };
}

export interface WorkspaceChannelUpdateDealStageEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.DEAL_STAGE_UPDATE;
  data: { deal_stage: DealStage };
}

export interface WorkspaceChannelDeleteDealStageEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.DEAL_STAGE_DELETE;
  data: { deal_stage_id: string };
}

export interface WorkspaceChannelCreateDealEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.DEAL_CREATE;
  data: { deal: Deal };
}

export interface WorkspaceChannelUpdateDealEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.DEAL_UPDATE;
  data: { deal: Deal };
}

export interface WorkspaceChannelDeleteDealEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.DEAL_DELETE;
  data: { deal_id: string };
}

export interface WorkspaceChannelCreateBoardEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.BOARD_CREATE;
  data: { board: Board };
}

export interface WorkspaceChannelUpdateBoardEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.BOARD_UPDATE;
  data: { board: Board };
}

export interface WorkspaceChannelDeleteBoardEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.BOARD_DELETE;
  data: { board_id: string };
}

export interface WorkspaceChannelCreateBoardLabelEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.BOARD_LABEL_CREATE;
  data: { board_label: BoardLabel };
}

export interface WorkspaceChannelUpdateBoardLabelEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.BOARD_LABEL_UPDATE;
  data: { board_label: BoardLabel };
}

export interface WorkspaceChannelDeleteBoardLabelEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.BOARD_LABEL_DELETE;
  data: { board_id: string; board_label_id: string };
}

export interface WorkspaceChannelCreateBoardListEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.BOARD_LIST_CREATE;
  data: { board_list: BoardList };
}

export interface WorkspaceChannelUpdateBoardListEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.BOARD_LIST_UPDATE;
  data: { board_list: BoardList };
}

export interface WorkspaceChannelDeleteBoardListEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.BOARD_LIST_DELETE;
  data: { board_id: string; board_list_id: string };
}

export interface WorkspaceChannelCreateTaskEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.TASK_CREATE;
  data: { task: Task };
}

export interface WorkspaceChannelUpdateTaskEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.TASK_UPDATE;
  data: { task: Task };
}

export interface WorkspaceChannelDeleteTaskEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.TASK_DELETE;
  data: { board_id?: string; task_id: string };
}

export interface WorkspaceChannelCreateTimeEntryEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.TIME_ENTRY_CREATE;
  data: { entry: TimeEntry };
}

export interface WorkspaceChannelUpdateTimeEntryEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.TIME_ENTRY_UPDATE;
  data: { entry: TimeEntry; timer_action?: TimeEntryTimerAction };
}

export interface WorkspaceChannelDeleteTimeEntryEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.TIME_ENTRY_DELETE;
  data: { time_entry_id: string; user_id: string };
}

export interface WorkspaceChannelLedgerItemAttachmentsReadyEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.LEDGER_ITEM_ATTACHMENTS_READY;
  data: { ledger_item: LedgerItem };
}

export interface WorkspaceChannelCreateAccountEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.ACCOUNT_CREATE;
  data: { account: Account };
}

export interface WorkspaceChannelUpdateAccountEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.ACCOUNT_UPDATE;
  data: { account: Account };
}

export interface WorkspaceChannelDeleteAccountEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.ACCOUNT_DELETE;
  data: { account_id: string };
}

export interface WorkspaceChannelCreateTransactionEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.TRANSACTION_CREATE;
  data: { transaction: Transaction };
}

export interface WorkspaceChannelUpdateTransactionEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.TRANSACTION_UPDATE;
  data: { transaction: Transaction };
}

export interface WorkspaceChannelDeleteTransactionEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.TRANSACTION_DELETE;
  data: { transaction_id: string };
}

export interface WorkspaceChannelCreateExpenseEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.EXPENSE_CREATE;
  data: { expense: Expense };
}

export interface WorkspaceChannelUpdateExpenseEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.EXPENSE_UPDATE;
  data: { expense: Expense };
}

export interface WorkspaceChannelDeleteExpenseEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.EXPENSE_DELETE;
  data: { expense_id: string };
}

export interface WorkspaceChannelCreateConversationEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.CONVERSATION_CREATE;
  data: { conversation: Conversation };
}

export interface WorkspaceChannelUpdateConversationEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.CONVERSATION_UPDATE;
  data: { conversation: Conversation };
}

export interface WorkspaceChannelDeleteConversationEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.CONVERSATION_DELETE;
  data: { conversation_id: string };
}

export interface WorkspaceChannelCreateWidgetSessionEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.WIDGET_SESSION_CREATE;
  data: { widget_session: WidgetSession };
}

export interface WorkspaceChannelUpdateWidgetSessionEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.WIDGET_SESSION_UPDATE;
  data: { widget_session: WidgetSession };
}

export interface WorkspaceChannelDeleteWidgetSessionEvent
  extends WorkspaceChannelEventBase {
  type: WorkspaceChannelEventType.WIDGET_SESSION_DELETE;
  data: { widget_session_id: string };
}

export type WorkspaceChannelEvent =
  | WorkspaceChannelCreateWorkspaceEvent
  | WorkspaceChannelUpdateWorkspaceEvent
  | WorkspaceChannelDeleteWorkspaceEvent
  | WorkspaceChannelCreateSubscriptionEvent
  | WorkspaceChannelUpdateSubscriptionEvent
  | WorkspaceChannelDeleteSubscriptionEvent
  | WorkspaceChannelCreateSettingEvent
  | WorkspaceChannelUpdateSettingEvent
  | WorkspaceChannelDeleteSettingEvent
  | WorkspaceChannelCreateDealStageEvent
  | WorkspaceChannelUpdateDealStageEvent
  | WorkspaceChannelDeleteDealStageEvent
  | WorkspaceChannelCreateDealEvent
  | WorkspaceChannelUpdateDealEvent
  | WorkspaceChannelDeleteDealEvent
  | WorkspaceChannelCreateBoardEvent
  | WorkspaceChannelUpdateBoardEvent
  | WorkspaceChannelDeleteBoardEvent
  | WorkspaceChannelCreateBoardLabelEvent
  | WorkspaceChannelUpdateBoardLabelEvent
  | WorkspaceChannelDeleteBoardLabelEvent
  | WorkspaceChannelCreateBoardListEvent
  | WorkspaceChannelUpdateBoardListEvent
  | WorkspaceChannelDeleteBoardListEvent
  | WorkspaceChannelCreateTaskEvent
  | WorkspaceChannelUpdateTaskEvent
  | WorkspaceChannelDeleteTaskEvent
  | WorkspaceChannelCreateTimeEntryEvent
  | WorkspaceChannelUpdateTimeEntryEvent
  | WorkspaceChannelDeleteTimeEntryEvent
  | WorkspaceChannelLedgerItemAttachmentsReadyEvent
  | WorkspaceChannelCreateAccountEvent
  | WorkspaceChannelUpdateAccountEvent
  | WorkspaceChannelDeleteAccountEvent
  | WorkspaceChannelCreateTransactionEvent
  | WorkspaceChannelUpdateTransactionEvent
  | WorkspaceChannelDeleteTransactionEvent
  | WorkspaceChannelCreateExpenseEvent
  | WorkspaceChannelUpdateExpenseEvent
  | WorkspaceChannelDeleteExpenseEvent
  | WorkspaceChannelCreateConversationEvent
  | WorkspaceChannelUpdateConversationEvent
  | WorkspaceChannelDeleteConversationEvent
  | WorkspaceChannelCreateWidgetSessionEvent
  | WorkspaceChannelUpdateWidgetSessionEvent
  | WorkspaceChannelDeleteWidgetSessionEvent
  | WorkspaceChannelCallEvent;

export interface ExpenseCategory {
  id?: string;
  name?: string;
  color?: string;
  editable?: boolean;
  parent_id?: string;
  workspace_id?: string;
  sub_categories?: ExpenseCategory[];
  parent_category?: ExpenseCategory | null;
}

export interface LedgerItemTemplate {
  id?: string;
  name?: string;
  premium?: boolean;
  enabled?: boolean;
  cover_url?: string;
}

export interface ReferralSource {
  id?: string;
  name?: string;
}

export enum ImportTimeEntryGroupByOption {
  CUSTOM_DESCRIPTION = "custom_description",
  DESCRIPTION = "description",
  WORK_TYPE = "work_type",
  DATE = "date",
  DATE_HOUR_DESCRIPTION = "date_hour_description",
}

export interface GroupedTimeEntries {
  description: string;
  rate: number;
  entries: TimeEntry[];
  fixed_rate: boolean;
}

export type PermissionRole = "owner" | "accountant";

export interface Accountant {
  id?: string;
  email?: string;
  first_name?: string;
  last_name?: string;
  company_name?: string;
  locale?: string;
  full_name?: string;
}

export interface AccountantCurrentUser extends Accountant {}

export interface AccountantWorkspace {
  id: string;
  business_name: string;
  setting: { default_currency: string; number_format: string; date_format: string };
}

export interface AccountantIntegration {
  type: string;
  name: string;
  icon: string;
  description: string;
  connected: boolean;
  requested_at: string | null;
  can_request: boolean;
}

export interface AccountantAccountingSync {
  last_accounting_sync_at: string | null;
  can_sync: boolean;
}

export type AccountantConnectionStatus = "pending" | "accepted";
export type AccountantConnectionInitiator = "accountant" | "workspace";

export interface AccountantConnection {
  id: string;
  status: AccountantConnectionStatus;
  initiated_by: AccountantConnectionInitiator;
  email: string;
  accepted_at?: string;
  created_at: string;
  accountant?: Accountant;
  workspace?: AccountantWorkspace;
}

export interface Device {
  id?: string;
  token?: string | null | undefined;
  user_id?: string;
}

export enum MimeTypes {
  ALL = "*",
  PDF = "application/pdf",
  JPEG = "image/jpeg",
  JPG = "image/jpg",
  PNG = "image/png",
  GIF = "image/gif",
  SVG = "image/svg+xml",
  CSV = "text/csv",
  EXCEL = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  TEXT_XML = "text/xml",
  APPLICATION_XML = "application/xml",
  WEBP = "image/webp",
  ICO = "image/vnd.microsoft.icon",
}

export type PaymentForm = MolliePaymentForm | StripePaymentForm;

export interface MolliePaymentForm {
  type: IntegrationType.MOLLIE;
  data: {
    id: string;
    _links: {
      checkout: {
        href: string;
      };
    };
  };
}

export interface StripePaymentForm {
  type: IntegrationType.STRIPE;
  data: {
    public_key: string;
    account_id: string;
    session_id: string;
  };
}

export enum BizzeyFileType {
  DIRECTORY = "directory",
  FILE = "file",
}

export enum BizzeyFileResourceType {
  CONTACT = "Contact",
  PROJECT = "Project",
  TASK = "Task",
  WORKSPACE = "Workspace",
  DEAL = "Deal",
}

export interface BizzeyFile {
  id?: string;
  name?: string;
  type?: BizzeyFileType;
  parent_file_id?: string;
  attachment_file_name?: string;
  attachment_content_type?: string;
  attachment_file_size?: number;
  attachment_url?: string | null;
  attachment_download_url?: string | null;
  attachment?: any;
  resource_type?: BizzeyFileResourceType;
  resource_id?: string;
  created_at?: string;
  updated_at?: string;
}

export interface InvoiceMetadata {
  project_budget?: number;
  unbilled_time_entries: {
    count: number;
    amount: number;
  };
  unbilled_expenses: {
    count: number;
    amount: number;
  };
  advancement_invoices: {
    quotation_number?: string;
    count?: number;
    remaining_net_amount?: number;
  };
}

export enum SmtpAuthType {
  LOGIN = "login",
  PLAIN = "plain",
  CRAM_MD5 = "cram-md5",
}

export enum SmtpSSLType {
  SSL = "ssl",
  TLS = "tls",
}
export interface SMTP {
  id?: string;
  helo_domain?: string;
  domain?: string;
  username?: string;
  password?: string;
  auth_type?: SmtpAuthType;
  ssl_type?: SmtpSSLType;
  port?: number;
  from_name?: string;
  from_email?: string;
}

export interface SendEmailParams {
  to?: string[];
  cc?: string[];
  bcc?: string[];
  subject?: string;
  body?: string;
  attachment_ids?: string[];
  test_email?: boolean;
}

export interface SendLedgerItemEmailParams {
  ledger_item_id: string;
  to: string[];
  cc: string[];
  bcc: string[];
  subject: string;
  body: string;
  reminder?: boolean;
  attach_ledger_item?: boolean;
  attachment_ids: string[];
  test_email?: boolean;
}

export interface PreviewAttachment {
  id: string;
  name: string;
  url: string;
  file_size: number;
  content_type: string;
  created_at?: string;
}

export enum CustomFieldType {
  // i18n.t('CustomFieldType::string')
  STRING = "string",
  // i18n.t('CustomFieldType::text')
  TEXT = "text",
  // i18n.t('CustomFieldType::single_option')
  SINGLE_OPTION = "single_option",
  // i18n.t('CustomFieldType::multiple_option')
  MULTIPLE_OPTION = "multiple_option",
  // i18n.t('CustomFieldType::date')
  DATE = "date",
  // i18n.t('CustomFieldType::money')
  MONEY = "money",
  // i18n.t('CustomFieldType::number')
  NUMBER = "number",
  // i18n.t('CustomFieldType::boolean')
  BOOLEAN = "boolean",
  // i18n.t('CustomFieldType::email')
  EMAIL = "email",
  // i18n.t('CustomFieldType::phone_number')
  PHONE_NUMBER = "phone_number",
  // i18n.t('CustomFieldType::url')
  URL = "url",
}

export enum CustomFieldModel {
  // i18n.t('CustomFieldModel::contact')
  // i18n.t('CustomFieldModel::contact_plural')
  CLIENT = "contact",
  // i18n.t('CustomFieldModel::supplier')
  // i18n.t('CustomFieldModel::supplier_plural')
  SUPPLIER = "supplier",
  // i18n.t('CustomFieldModel::project')
  // i18n.t('CustomFieldModel::project_plural')
  PROJECT = "project",
  // i18n.t('CustomFieldModel::time_entry')
  // i18n.t('CustomFieldModel::time_entry_plural')
  TIME_ENTRY = "time_entry",
  // i18n.t('CustomFieldModel::invoice')
  // i18n.t('CustomFieldModel::invoice_plural')
  INVOICE = "invoice",
  // i18n.t('CustomFieldModel::expense')
  // i18n.t('CustomFieldModel::expense_plural')
  EXPENSE = "expense",
  // i18n.t('CustomFieldModel::product')
  // i18n.t('CustomFieldModel::product_plural')
  PRODUCT = "product",
  // i18n.t('CustomFieldModel::task')
  // i18n.t('CustomFieldModel::task_plural')
  TASK = "task",
  // i18n.t('CustomFieldModel::calendar_event')
  // i18n.t('CustomFieldModel::calendar_event_plural')
  CALENDAR_EVENT = "calendar_event",
}

export interface SingleOptionCustomFieldConfig {
  options: { label: string; value: string }[];
}
export interface MultipleOptionCustomFieldConfig {
  options: { label: string; value: string }[];
}

export type CustomFieldConfig =
  | object
  | SingleOptionCustomFieldConfig
  | MultipleOptionCustomFieldConfig;

export interface CustomFieldBase {
  id?: string;
  name?: string;
  type?: CustomFieldType | string;
  model?: CustomFieldModel | string;
  required?: boolean;
  position?: number;
  workspace_id?: string;
  config?: CustomFieldConfig;
}

export interface StringCustomField extends CustomFieldBase {
  type: CustomFieldType.STRING;
}

export interface TextCustomField extends CustomFieldBase {
  type: CustomFieldType.TEXT;
}

export interface SingleOptionCustomField extends CustomFieldBase {
  type: CustomFieldType.SINGLE_OPTION;
  config?: {
    options: { label: string; value: string }[];
    allowOptionCreation?: boolean;
  };
}

export interface MultipleOptionCustomField extends CustomFieldBase {
  type: CustomFieldType.MULTIPLE_OPTION;
  config?: {
    options: { label: string; value: string }[];
    allowOptionCreation?: boolean;
  };
}

export interface DateCustomField extends CustomFieldBase {
  type: CustomFieldType.DATE;
}

export interface MoneyCustomField extends CustomFieldBase {
  type: CustomFieldType.MONEY;
}

export interface NumberCustomField extends CustomFieldBase {
  type: CustomFieldType.NUMBER;
}

export interface BooleanCustomField extends CustomFieldBase {
  type: CustomFieldType.BOOLEAN;
}

export interface EmailCustomField extends CustomFieldBase {
  type: CustomFieldType.EMAIL;
}

export interface PhonenumberCustomField extends CustomFieldBase {
  type: CustomFieldType.PHONE_NUMBER;
}

export interface UrlCustomField extends CustomFieldBase {
  type: CustomFieldType.URL;
}

export type CustomField =
  | StringCustomField
  | TextCustomField
  | SingleOptionCustomField
  | MultipleOptionCustomField
  | DateCustomField
  | MoneyCustomField
  | NumberCustomField
  | BooleanCustomField
  | EmailCustomField
  | PhonenumberCustomField
  | UrlCustomField;

export type ModelCustomFieldsType = {
  [key: string]: any;
};

export enum ResourceListFilterType {
  STRING = "text",
  SINGLE_OPTION = "single_option",
  SINGLE_RESOURCE = "single_resource",
  MULTI_RESOURCE = "multi_resource",
  MULTIPLE_OPTION = "multiple_option",
  DATE = "date",
  NUMBER = "number",
  BOOLEAN = "boolean",
}

export enum ResourceListFilterPredicate {
  // i18n.t('ResourceListFilterPredicate::contains')
  CONTAINS = "contains",
  // i18n.t('ResourceListFilterPredicate::equals')
  EQUALS = "equals",
  // i18n.t('ResourceListFilterPredicate::between')
  BETWEEN = "between",
  // i18n.t('ResourceListFilterPredicate::greaterThan')
  GREATER_THAN = "greaterThan",
  // i18n.t('ResourceListFilterPredicate::lessThan')
  LESS_THAN = "lessThan",
  // i18n.t('ResourceListFilterPredicate::isAfter')
  IS_AFTER = "isAfter",
  // i18n.t('ResourceListFilterPredicate::isAfterOrOn')
  IS_AFTER_OR_ON = "isAfterOrOn",
  // i18n.t('ResourceListFilterPredicate::isBefore')
  IS_BEFORE = "isBefore",
  // i18n.t('ResourceListFilterPredicate::isBeforeOrOn')
  IS_BEFORE_OR_ON = "isBeforeOrOn",
  // i18n.t('ResourceListFilterPredicate::present')
  PRESENT = "present",
}

export interface ResourceFilterBase<T> {
  name: T;
  label: string;
  visible?: boolean;
}

export interface StringResourceFilter<T> extends ResourceFilterBase<T> {
  type: ResourceListFilterType.STRING;
}

export interface SingleOptionResourceFilter<T> extends ResourceFilterBase<T> {
  type: ResourceListFilterType.SINGLE_OPTION;
  options: { label: string; value: string }[];
}

export interface SingleResourceFilter<T> extends ResourceFilterBase<T> {
  type: ResourceListFilterType.SINGLE_RESOURCE;
  resourceType: ResourceCreatablePowerSelectType;
  params?: { [key: string]: any };
  createParams?: object;
  isValidNewOption?: (
    inputValue: string,
    value: { label: string; value: string },
    options: any,
  ) => boolean;
}

export interface MultiResourceFilter<T> extends ResourceFilterBase<T> {
  type: ResourceListFilterType.MULTI_RESOURCE;
  resourceType: ResourceCreatablePowerSelectType;
  params?: { [key: string]: any };
  createParams?: object;
  // See ResourceCreatablePowerSelect isGroupHeadingSelectable
  isGroupHeadingSelectable?: boolean;
  isValidNewOption?: (
    inputValue: string,
    value: { label: string; value: string },
    options: any,
  ) => boolean;
}

export interface MultipleOptionResourceFilter<T> extends ResourceFilterBase<T> {
  type: ResourceListFilterType.MULTIPLE_OPTION;
  options: { label: string; value: string }[];
}

export interface DateResourceFilter<T> extends ResourceFilterBase<T> {
  type: ResourceListFilterType.DATE;
}

export interface NumberResourceFilter<T> extends ResourceFilterBase<T> {
  type: ResourceListFilterType.NUMBER;
}

export interface BooleanResourceFilter<T> extends ResourceFilterBase<T> {
  type: ResourceListFilterType.BOOLEAN;
}

export type ResourceFilter<T> =
  | StringResourceFilter<T>
  | SingleOptionResourceFilter<T>
  | SingleResourceFilter<T>
  | MultiResourceFilter<T>
  | MultipleOptionResourceFilter<T>
  | DateResourceFilter<T>
  | NumberResourceFilter<T>
  | BooleanResourceFilter<T>;

export interface ResourceColumn {
  label: string;
  value: string;
}

export interface IPositionable {
  position?: number;
}

/**
 * Used to define events related to a resource
 */
export enum CalendarResourceType {
  PROJECT_EVENT_TYPE = "project",
  QUOTATION_EVENT_TYPE = "quotation",
  INVOICE_EVENT_TYPE = "invoice",
  TASK_EVENT_TYPE = "task",
  CALENDAR_EVENT_TYPE = "calendar_event",
  DEAL_EVENT_TYPE = "deal",
}

export enum CalendarEventReminderType {
  // i18n.t('CalendarEventReminderType::notification')
  NOTIFICATION = "notification",
  // i18n.t('CalendarEventReminderType::email')
  EMAIL = "email",
}

export enum CalendarEventReminderUnit {
  // i18n.t('CalendarEventReminderUnit::minute')
  // i18n.t('CalendarEventReminderUnit::minute_plural')
  MINUTE = "minute",
  // i18n.t('CalendarEventReminderUnit::hour')
  // i18n.t('CalendarEventReminderUnit::hour_plural')
  HOUR = "hour",
  // i18n.t('CalendarEventReminderUnit::day')
  // i18n.t('CalendarEventReminderUnit::day_plural')
  DAY = "day",
  // i18n.t('CalendarEventReminderUnit::week')
  // i18n.t('CalendarEventReminderUnit::week_plural')
  WEEK = "week",
}
export interface CalendarEventReminder {
  type?: CalendarEventReminderType;
  interval?: number;
  interval_unit?: CalendarEventReminderUnit;
}

export enum CalendarEventType {
  // i18n.t('CalendarEventType::event')
  EVENT = "event",
  // i18n.t('CalendarEventType::appointment')
  APPOINTMENT = "appointment",
  // i18n.t('CalendarEventType::call')
  CALL = "call",
  // i18n.t('CalendarEventType::focus_time')
  FOCUS_TIME = "focus_time",
  // i18n.t('CalendarEventType::leave')
  HOLIDAY = "leave",
}

export enum CalendarEventStatus {
  // i18n.t('CalendarEventStatus::confirmed')
  CONFIRMED = "confirmed",
  // i18n.t('CalendarEventStatus::tentative')
  TENTATIVE = "tentative",
  // i18n.t('CalendarEventStatus::cancelled')
  CANCELLED = "cancelled",
}

export enum CalendarEventProvider {
  // i18n.t('CalendarEventProvider::google')
  GOOGLE = "google",
  // i18n.t('CalendarEventProvider::microsoft')
  MICROSOFT = "microsoft",
}

export enum CalendarEventAttendeeStatus {
  ACTION_REQUIRED = "action_required",
  DECLINED = "declined",
  TENTATIVE = "tentative",
  ACCEPTED = "accepted",
}

export interface CalendarEventAttendee {
  id?: string;
  calendar_event_id?: string;
  calendar_event?: CalendarEvent;
  contact_id?: string;
  contact?: Contact;
  status?: CalendarEventAttendeeStatus;
  _destroy?: boolean;
}

export interface CalendarEvent {
  id?: string;
  title?: string;
  type?: CalendarEventType;
  status?: CalendarEventStatus;
  start?: string | Date;
  end?: string | Date;
  timezone?: string;
  all_day?: boolean;
  recurring_schedule?: RecurringSchedule;
  location?: string;
  description?: string;
  attendees?: CalendarEventAttendee[];
  reminders?: CalendarEventReminder[];
  provider?: CalendarEventProvider;
  uid?: string;
  meeting_link?: string;
  custom_fields?: ModelCustomFieldsType;
  contact?: Contact;
  project?: Project;
  contact_id?: string;
  project_id?: string;
  deal_id?: string;
  user?: User;
  user_id?: string;
  workspace_id?: string;
  created_at?: string;
}

export enum CalendarViewEventType {
  // i18n.t('CalendarViewEventType::calendar_event')
  // i18n.t('CalendarViewEventType::calendar_event_plural')
  CALENDAR_EVENT = "calendar_event",
  // i18n.t('CalendarViewEventType::project')
  // i18n.t('CalendarViewEventType::project_plural')
  PROJECT = "project",
  // i18n.t('CalendarViewEventType::quotation')
  // i18n.t('CalendarViewEventType::quotation_plural')
  QUOTATION = "quotation",
  // i18n.t('CalendarViewEventType::invoice')
  // i18n.t('CalendarViewEventType::invoice_plural')
  INVOICE = "invoice",
  // i18n.t('CalendarViewEventType::recurring_invoice')
  // i18n.t('CalendarViewEventType::recurring_invoice_plural')
  RECURRING_INVOICE = "recurring_invoice",
  // i18n.t('CalendarViewEventType::task')
  // i18n.t('CalendarViewEventType::task_plural')
  TASK = "task",
  // i18n.t('CalendarViewEventType::planned_task')
  // i18n.t('CalendarViewEventType::planned_task_plural')
  PLANNED_TASK = "planned_task",
  // i18n.t('CalendarViewEventType::deal')
  // i18n.t('CalendarViewEventType::deal_plural')
  DEAL = "deal",
}

export interface CalendarViewEventBase {
  title?: string;
  start?: Date;
  end?: Date;
  all_day?: boolean;
  type: CalendarViewEventType;
  disabled?: boolean;
}

export interface CalendarViewProjectEvent extends CalendarViewEventBase {
  type: CalendarViewEventType.PROJECT;
  resource: Project;
}

export interface CalendarViewQuotationEvent extends CalendarViewEventBase {
  type: CalendarViewEventType.QUOTATION;
  resource: LedgerItem;
}

export interface CalendarViewInvoiceEvent extends CalendarViewEventBase {
  type: CalendarViewEventType.INVOICE;
  resource: LedgerItem;
}

export interface CalendarViewRecurringInvoiceEvent
  extends CalendarViewEventBase {
  type: CalendarViewEventType.RECURRING_INVOICE;
  resource: LedgerItem;
}

export interface CalendarViewTaskEvent extends CalendarViewEventBase {
  type: CalendarViewEventType.TASK;
  resource: Task;
}

export interface CalendarViewPlannedTaskEvent extends CalendarViewEventBase {
  type: CalendarViewEventType.PLANNED_TASK;
  resource: Task;
}

export interface CalendarViewCalendarEvent extends CalendarViewEventBase {
  type: CalendarViewEventType.CALENDAR_EVENT;
  resource: CalendarEvent;
}

export interface CalendarViewDealEvent extends CalendarViewEventBase {
  type: CalendarViewEventType.DEAL;
  resource: Deal;
}

export type CalendarViewEvent =
  | CalendarViewProjectEvent
  | CalendarViewQuotationEvent
  | CalendarViewInvoiceEvent
  | CalendarViewRecurringInvoiceEvent
  | CalendarViewTaskEvent
  | CalendarViewPlannedTaskEvent
  | CalendarViewCalendarEvent
  | CalendarViewDealEvent;

export type ResourceCreatablePowerSelectType =
  | "company"
  | "person"
  | "contact"
  | "company_with_email"
  | "person_with_email"
  | "contact_with_email"
  | "contact_group"
  | "project"
  | "project_tag"
  | "user"
  | "contact"
  | "deal_stage"
  | "deal"
  | "work_type"
  | "board"
  | "board_list"
  | "document_tag"
  | "playbook"
  | "sequence"
  | "account"
  | "help_center"
  | "article_tag"
  | "news_center"
  | "news_tag"
  | "financial_year"
  | "expense_category";

export interface DisplayableError {
  field: string;
  message: string;
}

export interface ExtractionTax {
  code?: string;
  amount?: number;
  rate?: number;
}

export interface ExtractionLineItem {
  description?: string;
  product_code?: string;
  quantity?: number;
  price?: number;
  tax_amount?: number;
  tax_rate?: number;
  total_amount?: number;
}

export interface InvoiceExtractionData {
  type: "invoice";
  currency?: string;
  issue_date?: string;
  due_date?: string;
  locale?: string;
  supplier_account_number?: string;
  supplier_address?: string;
  supplier_iban?: string;
  supplier_name?: string;
  supplier_routing_number?: string;
  supplier_swift?: string;
  supplier_vat?: string;
  taxes?: Array<ExtractionTax>;
  total_exclusive?: number;
  total_inclusive?: number;
  total_tax?: number;
  line_items?: Array<ExtractionLineItem>;
}

export type ReceiptExtractionCategory =
  | "accommodation"
  | "food"
  | "gasoline"
  | "parking"
  | "transport"
  | "toll"
  | "miscellaneous";
export interface ReceiptExtractionData {
  type: "receipt";
  currency?: string;
  country?: string;
  issue_date?: string;
  time?: string;
  locale?: string;
  supplier_name?: string;
  supplier_vat?: string | null;
  taxes?: Array<ExtractionTax>;
  total_exclusive?: number;
  total_inclusive?: number;
  total_tax?: number;
  category: ReceiptExtractionCategory;
}

export interface UBLExtractionData {
  type: "ubl";
  data: UBLData;
}

export type ExpenseExtractionData =
  | InvoiceExtractionData
  | ReceiptExtractionData
  | UBLExtractionData;

export enum ContractStatus {
  // i18n.t('ContractStatus::draft')
  DRAFT = "draft",
  // i18n.t('ContractStatus::pending')
  PENDING = "pending",
  // i18n.t('ContractStatus::signed')
  SIGNED = "signed",
  // i18n.t('ContractStatus::rejected')
  REJECTED = "rejected",
}

export interface Contract {
  id?: string;
  name?: string;
  status?: ContractStatus;
  workspace_id?: string;
  contact_id?: string;
  contact?: Contact;
  project_id?: string;
  project?: Project;
  signees?: Contact[];
  signee_ids?: string[];
  created_at?: string;
  content_blocks?: ContentBlock[];
  signatures?: Signature[];
}

export enum ContentBlockResource {
  CONTRACT = "contract",
  PROPOSAL = "proposal",
  FORM = "form",
  PLAYBOOK = "playbook",
  CONTENT_BLOCK_TEMPLATE = "content_block_template",
}

export enum ContentBlockType {
  // i18n.t('ContentBlockType::text')
  TEXT = "text",
  // i18n.t('ContentBlockType::image')
  IMAGE = "image",
  // i18n.t('ContentBlockType::sign')
  SIGN = "sign",
  // i18n.t('ContentBlockType::intro')
  INTRO = "intro",
  // i18n.t('ContentBlockType::items')
  ITEMS = "items",
  // i18n.t('ContentBlockType::summary')
  SUMMARY = "summary",
  // i18n.t('ContentBlockType::input')
  INPUT = "input",
  // i18n.t('ContentBlockType::address_input')
  ADDRESS_INPUT = "address_input",
  // i18n.t('ContentBlockType::countries_input')
  COUNTRIES_INPUT = "countries_input",
  // i18n.t('ContentBlockType::date_input')
  DATE_INPUT = "date_input",
  // i18n.t('ContentBlockType::dropdown_input')
  DROPDOWN_INPUT = "dropdown_input",
  // i18n.t('ContentBlockType::email_input')
  EMAIL_INPUT = "email_input",
  // i18n.t('ContentBlockType::file_upload_input')
  FILE_UPLOAD_INPUT = "file_upload_input",
  // i18n.t('ContentBlockType::link_input')
  LINK_INPUT = "link_input",
  // i18n.t('ContentBlockType::long_text_input')
  LONG_TEXT_INPUT = "long_text_input",
  // i18n.t('ContentBlockType::number_input')
  NUMBER_INPUT = "number_input",
  // i18n.t('ContentBlockType::phone_number_input')
  PHONE_NUMBER_INPUT = "phone_number_input",
  // i18n.t('ContentBlockType::text_input')
  TEXT_INPUT = "text_input",
  // i18n.t('ContentBlockType::slider_input')
  SLIDER_INPUT = "slider_input",
  // i18n.t('ContentBlockType::submit')
  SUBMIT = "submit",
  // i18n.t('ContentBlockType::pdf')
  PDF = "pdf",
  // i18n.t('ContentBlockType::question_and_answer')
  QUESTION_AND_ANSWER = "question_and_answer",
}

export interface ContentBlockBase {
  id?: string;
  position?: number;
  type?: ContentBlockType;
}

export interface TextBlock extends ContentBlockBase {
  type: ContentBlockType.TEXT;
  content?: string;
}

export interface ImageBlock extends ContentBlockBase {
  type: ContentBlockType.IMAGE;
  image_url?: string | null;
}

export interface PDFBlock extends ContentBlockBase {
  type: ContentBlockType.PDF;
  pdf_url?: string | null;
  image_urls?: string[];
}

export interface SignBlock extends ContentBlockBase {
  type: ContentBlockType.SIGN;
  title?: string;
  description?: string;
  action?: string;
}

export interface IntroBlock extends ContentBlockBase {
  type: ContentBlockType.INTRO;
  to?: string;
  from?: string;
}

export enum ItemsView {
  // t('ItemsView::table')
  TABLE = "table",
  // t('ItemsView::card')
  CARD = "card",
}

export enum ItemsSelectionType {
  SINGLE = "single",
  MULTI = "multi",
}

export enum ItemsSelectionRequirementType {
  REQUIRED = "required",
  OPTIONAL = "optional",
}

export enum ItemBlockType {
  // i18n.t('ItemBlockType::non_recurring')
  NON_RECURRING = "non_recurring",
  // i18n.t('ItemBlockType::recurring')
  RECURRING = "recurring",
}

export enum ItemBlockDiscountType {
  // t('ItemBlockDiscountType::percentage')
  PERCENTAGE = "percentage",
  // t('ItemBlockDiscountType::fixed')
  FIXED = "fixed",
}

export interface ItemBlock {
  id?: string;
  cover?: string;
  title?: string;
  description?: string;
  amount?: number;
  type?: ItemBlockType;
  quantity?: number;
  tax_rate?: number;
  tax_code?: string;
  discount_type?: ItemBlockDiscountType;
  discount?: number;
  selected?: boolean;
  quantity_adjustment_allowed?: boolean;
}

export interface ItemsBlock extends ContentBlockBase {
  type: ContentBlockType.ITEMS;
  title?: string;
  view?: ItemsView;
  contact_selection_enabled?: boolean;
  selection_type?: ItemsSelectionType;
  selection_requirement_type?: ItemsSelectionRequirementType;
  items: ItemBlock[];
}

export interface SummaryBlock extends ContentBlockBase {
  type: ContentBlockType.SUMMARY;
  title?: string;
}

export interface InputBlockBase extends ContentBlockBase {
  name?: string;
  description?: string;
  placeholder?: string;
  required?: boolean;
}

export interface AddressInputBlock extends InputBlockBase {
  type: ContentBlockType.ADDRESS_INPUT;
  country_options: { label: string; value: string }[];
}

export interface CountriesInputBlock extends InputBlockBase {
  type: ContentBlockType.COUNTRIES_INPUT;
  country_options?: { label: string; value: string }[];
}

export interface DateInputBlock extends InputBlockBase {
  type: ContentBlockType.DATE_INPUT;
}

export interface DropdownInputBlock extends InputBlockBase {
  type: ContentBlockType.DROPDOWN_INPUT;
  options?: string[];
  allow_multiple_selection?: boolean;
}

export interface EmailInputBlock extends InputBlockBase {
  type: ContentBlockType.EMAIL_INPUT;
}

export interface FileUploadInputBlock extends InputBlockBase {
  type: ContentBlockType.FILE_UPLOAD_INPUT;
}

export interface FileUploadInputBlock extends InputBlockBase {
  type: ContentBlockType.FILE_UPLOAD_INPUT;
}

export interface LinkInputBlock extends InputBlockBase {
  type: ContentBlockType.LINK_INPUT;
}

export interface LongTextInputBlock extends InputBlockBase {
  type: ContentBlockType.LONG_TEXT_INPUT;
}

export interface NumberInputBlock extends InputBlockBase {
  type: ContentBlockType.NUMBER_INPUT;
  minimum_limit?: number;
  maximum_limit?: number;
}

export interface PhonenumberInputBlock extends InputBlockBase {
  type: ContentBlockType.PHONE_NUMBER_INPUT;
}

export interface TextInputBlock extends InputBlockBase {
  type: ContentBlockType.TEXT_INPUT;
}

export interface SliderInputBlock extends InputBlockBase {
  type: ContentBlockType.SLIDER_INPUT;
  minimum_limit?: number;
  maximum_limit?: number;
}

export enum QuestionAndAnswerType {
  OPEN = "open",
  LIST = "list",
}

export interface QuestionAndAnswerBlock extends ContentBlockBase {
  type?: ContentBlockType.QUESTION_AND_ANSWER;
  title?: string;
  required?: boolean;
  answer_type?: QuestionAndAnswerType;
  options?: string[];
  allow_multiple_selection?: boolean;
  answer?: string | string[];
}

export interface SubmitBlock extends ContentBlockBase {
  type: ContentBlockType.SUBMIT;
  text?: string;
}

export type ContentBlock =
  | TextBlock
  | ImageBlock
  | PDFBlock
  | SignBlock
  | IntroBlock
  | ItemsBlock
  | SummaryBlock
  | AddressInputBlock
  | CountriesInputBlock
  | DateInputBlock
  | DropdownInputBlock
  | EmailInputBlock
  | FileUploadInputBlock
  | LinkInputBlock
  | LongTextInputBlock
  | NumberInputBlock
  | PhonenumberInputBlock
  | TextInputBlock
  | SliderInputBlock
  | QuestionAndAnswerBlock
  | SubmitBlock;

export interface ContentBlockTemplate {
  id?: string;
  name?: string;
  resource_type?: ContentBlockResource;
  content_block?: ContentBlock;
}

export interface SearchableContentBlock {
  name: string;
  contentBlock: ContentBlockBase;
  contentBlockTemplate?: ContentBlockTemplate;
}

export enum ContractChannelEventType {
  CONTRACT_CREATE = "CONTRACT_CREATE",
  CONTRACT_UPDATE = "CONTRACT_UPDATE",
  CONTRACT_DELETE = "CONTRACT_DELETE",

  CONTENT_BLOCK_CREATE = "CONTENT_BLOCK_CREATE",
  CONTENT_BLOCK_UPDATE = "CONTENT_BLOCK_UPDATE",
  CONTENT_BLOCK_DELETE = "CONTENT_BLOCK_DELETE",
}

export type ContractChannelEvent =
  | ContractChannelCreateContractEvent
  | ContractChannelUpdateContractEvent
  | ContractChannelDeleteContractEvent
  | ContractChannelCreateContentBlockEvent
  | ContractChannelUpdateContentBlockEvent
  | ContractChannelDeleteContentBlockEvent;

export interface ContractChannelEventBase {
  type: ContractChannelEventType;
  data: object;
}

export interface ContractChannelCreateContractEvent
  extends ContractChannelEventBase {
  type: ContractChannelEventType.CONTRACT_CREATE;
  data: { contract: Contract };
}

export interface ContractChannelUpdateContractEvent
  extends ContractChannelEventBase {
  type: ContractChannelEventType.CONTRACT_UPDATE;
  data: { contract: Contract };
}

export interface ContractChannelDeleteContractEvent
  extends ContractChannelEventBase {
  type: ContractChannelEventType.CONTRACT_DELETE;
  data: { contract_id: string };
}

export interface ContractChannelCreateContentBlockEvent
  extends ContractChannelEventBase {
  type: ContractChannelEventType.CONTENT_BLOCK_CREATE;
  data: { content_block: ContentBlock };
}

export interface ContractChannelUpdateContentBlockEvent
  extends ContractChannelEventBase {
  type: ContractChannelEventType.CONTENT_BLOCK_UPDATE;
  data: { content_block: ContentBlock };
}

export interface ContractChannelDeleteContentBlockEvent
  extends ContractChannelEventBase {
  type: ContractChannelEventType.CONTENT_BLOCK_DELETE;
  data: { content_block_id: string };
}

export interface SignatureResultBase {
  full_name: string;
}

export enum SignatureType {
  TYPED = "typed",
  DRAW = "draw",
  UPLOAD = "upload",
}

export interface TypeSignatureResult extends SignatureResultBase {
  type: SignatureType.TYPED;
}
export interface DrawSignatureResult extends SignatureResultBase {
  type: SignatureType.DRAW;
  base64: string;
}

export interface UploadSignatureResult extends SignatureResultBase {
  type: SignatureType.UPLOAD;
  signature: File;
}

export type SignatureResult =
  | TypeSignatureResult
  | DrawSignatureResult
  | UploadSignatureResult;

export interface Signature {
  id?: string;
  key?: string;
  type?: SignatureType;
  full_name?: string;
  ip_address?: string;
  signature_url?: string;
  signee?: Contact;
  signee_id?: string;
  signed_at?: string;
  created_at?: string;
  updated_at?: string;
}

export interface ContentBlockVariables {
  [key: string]: any;
}

export interface SendContractEmailParams {
  to: string[];
  subject: string;
  body: string;
  test_email?: boolean;
}

export interface VariableOption {
  name: string;
  label: string;
  value: string;
  options?: VariableOption[];
}

export enum ProposalStatus {
  // i18n.t('ProposalStatus::draft')
  DRAFT = "draft",
  // i18n.t('ProposalStatus::pending')
  PENDING = "pending",
  // i18n.t('ProposalStatus::accepted')
  ACCEPTED = "accepted",
  // i18n.t('ProposalStatus::cancelled')
  CANCELLED = "cancelled",
  // i18n.t('ProposalStatus::declined')
  DECLINED = "declined",
}

export interface Proposal {
  id?: string;
  name?: string;
  status?: ProposalStatus;
  expires_on?: string | Date;
  currency?: string;
  workspace_id?: string;
  contact_id?: string;
  contact?: Contact;
  project_id?: string;
  project?: Project;
  deal_id?: string;
  deal?: Deal;
  signees?: Contact[];
  signee_ids?: string[];
  created_at?: string;
  content_blocks?: ContentBlock[];
  signatures?: Signature[];
}

export interface SendProposalEmailParams {
  to: string[];
  subject: string;
  body: string;
  test_email?: boolean;
}

export enum ProposalChannelEventType {
  PROPOSAL_CREATE = "PROPOSAL_CREATE",
  PROPOSAL_UPDATE = "PROPOSAL_UPDATE",
  PROPOSAL_DELETE = "PROPOSAL_DELETE",

  CONTENT_BLOCK_CREATE = "CONTENT_BLOCK_CREATE",
  CONTENT_BLOCK_UPDATE = "CONTENT_BLOCK_UPDATE",
  CONTENT_BLOCK_DELETE = "CONTENT_BLOCK_DELETE",
}

export type ProposalChannelEvent =
  | ProposalChannelCreateProposalEvent
  | ProposalChannelUpdateProposalEvent
  | ProposalChannelDeleteProposalEvent
  | ProposalChannelCreateContentBlockEvent
  | ProposalChannelUpdateContentBlockEvent
  | ProposalChannelDeleteContentBlockEvent;

export interface ProposalChannelEventBase {
  type: ProposalChannelEventType;
  data: object;
}

export interface ProposalChannelCreateProposalEvent
  extends ProposalChannelEventBase {
  type: ProposalChannelEventType.PROPOSAL_CREATE;
  data: { proposal: Proposal };
}

export interface ProposalChannelUpdateProposalEvent
  extends ProposalChannelEventBase {
  type: ProposalChannelEventType.PROPOSAL_UPDATE;
  data: { proposal: Proposal };
}

export interface ProposalChannelDeleteProposalEvent
  extends ProposalChannelEventBase {
  type: ProposalChannelEventType.PROPOSAL_DELETE;
  data: { proposal_id: string };
}

export interface ProposalChannelCreateContentBlockEvent
  extends ProposalChannelEventBase {
  type: ProposalChannelEventType.CONTENT_BLOCK_CREATE;
  data: { content_block: ContentBlock };
}

export interface ProposalChannelUpdateContentBlockEvent
  extends ProposalChannelEventBase {
  type: ProposalChannelEventType.CONTENT_BLOCK_UPDATE;
  data: { content_block: ContentBlock };
}

export interface ProposalChannelDeleteContentBlockEvent
  extends ProposalChannelEventBase {
  type: ProposalChannelEventType.CONTENT_BLOCK_DELETE;
  data: { content_block_id: string };
}

export interface CurrencyOption {
  label: string;
  value: string;
  symbol: string;
}

export enum PaymentMethodType {
  CREDIT_CARD = "card",
  SEPA = "sepa_debit",
}

export interface Form {
  id?: string;
  name?: string;
  currency?: string;
  activation_date?: string | Date | any;
  expiration_date?: string | Date | any;
  target_email?: string;
  url?: string;
  embed_url?: string;
  redirect_url?: string;
  recaptcha_enabled?: boolean;
  recaptcha_secret?: string;
  response_limit?: number;
  workspace_id?: string;
  responses_count?: number;
  content_blocks?: ContentBlock[];
  task_create_enabled?: boolean;
  board_id?: string;
  board_list_id?: string;
  task_assignee_ids?: string[];
  created_at?: string;
  submittable?: boolean;
  enabled?: boolean;
}

export enum FormChannelEventType {
  FORM_CREATE = "FORM_CREATE",
  FORM_UPDATE = "FORM_UPDATE",
  FORM_DELETE = "FORM_DELETE",

  CONTENT_BLOCK_CREATE = "CONTENT_BLOCK_CREATE",
  CONTENT_BLOCK_UPDATE = "CONTENT_BLOCK_UPDATE",
  CONTENT_BLOCK_DELETE = "CONTENT_BLOCK_DELETE",

  FORM_RESPONSE_CREATE = "FORM_RESPONSE_CREATE",
  FORM_RESPONSE_UPDATE = "FORM_RESPONSE_UPDATE",
  FORM_RESPONSE_DELETE = "FORM_RESPONSE_DELETE",
}

export type FormChannelEvent =
  | FormChannelCreateFormEvent
  | FormChannelUpdateFormEvent
  | FormChannelDeleteFormEvent
  | FormChannelCreateContentBlockEvent
  | FormChannelUpdateContentBlockEvent
  | FormChannelDeleteContentBlockEvent
  | FormChannelCreateFormResponseEvent
  | FormChannelUpdateFormResponseEvent
  | FormChannelDeleteFormResponseEvent;

export interface FormChannelEventBase {
  type: FormChannelEventType;
  data: object;
}

export interface FormChannelCreateFormEvent extends FormChannelEventBase {
  type: FormChannelEventType.FORM_CREATE;
  data: { form: Form };
}

export interface FormChannelUpdateFormEvent extends FormChannelEventBase {
  type: FormChannelEventType.FORM_UPDATE;
  data: { form: Form };
}

export interface FormChannelDeleteFormEvent extends FormChannelEventBase {
  type: FormChannelEventType.FORM_DELETE;
  data: { form_id: string };
}

export interface FormChannelCreateContentBlockEvent
  extends FormChannelEventBase {
  type: FormChannelEventType.CONTENT_BLOCK_CREATE;
  data: { content_block: ContentBlock };
}

export interface FormChannelUpdateContentBlockEvent
  extends FormChannelEventBase {
  type: FormChannelEventType.CONTENT_BLOCK_UPDATE;
  data: { content_block: ContentBlock };
}

export interface FormChannelDeleteContentBlockEvent
  extends FormChannelEventBase {
  type: FormChannelEventType.CONTENT_BLOCK_DELETE;
  data: { content_block_id: string };
}

export interface FormChannelCreateFormResponseEvent {
  type: FormChannelEventType.FORM_RESPONSE_CREATE;
  data: { form_response: FormResponse };
}
export interface FormChannelUpdateFormResponseEvent {
  type: FormChannelEventType.FORM_RESPONSE_UPDATE;
  data: { form_response: FormResponse };
}
export interface FormChannelDeleteFormResponseEvent {
  type: FormChannelEventType.FORM_RESPONSE_DELETE;
  data: { form_response_id: string };
}

export interface FormResponse {
  id?: string;
  data?: { [key: string]: any };
  form_id?: string;
  form?: Form;
  viewed_at?: string | Date;
  created_at: string;
}

export interface BlobResponse {
  filename: string;
  blob: Blob;
}

export enum SpreadsheetExportType {
  // i18n.t('SpreadsheetExportType::xlsx')
  EXCEL = "xlsx",
  // i18n.t('SpreadsheetExportType::csv')
  CSV = "csv",
  // i18n.t('SpreadsheetExportType::ods')
  ODS = "ods",
}

export enum TimeTrackingViewReportMode {
  // t('TimeTrackingViewReportMode::week')
  WEEK = "week",
  // t('TimeTrackingViewReportMode::month')
  MONTH = "month",
  // t('TimeTrackingViewReportMode::quarter')
  QUARTER = "quarter",
  // t('TimeTrackingViewReportMode::year')
  YEAR = "year",
}

export enum TimeTrackingViewReportType {
  // t('TimeTrackingViewReportType::contact')
  CLIENT = "contact",
  // t('TimeTrackingViewReportType::project')
  PROJECT = "project",
  // t('TimeTrackingViewReportType::work_type')
  WORK_TYPE = "work_type",
  // t('TimeTrackingViewReportType::project_team')
  PROJECT_TEAM = "project_team",
  // t('TimeTrackingViewReportType::team')
  TEAM = "team",
}

export interface TimeTrackingReportDataRowBase {
  name: string;
  billable_hours: number;
  unbillable_hours: number;
  hours: number;
  cost_amount: number;
  billable_amount: number;
  net_amount: number;
}

export interface ContactTimeTrackingReportDataRow
  extends TimeTrackingReportDataRowBase {
  contact_id?: string;
}
export interface ProjectTimeTrackingReportDataRow
  extends TimeTrackingReportDataRowBase {
  project_id?: string;
  contact_id?: string;
  contact_name?: string;
  budget?: string | number;
}

export interface WorkTypeTimeTrackingReportDataRow
  extends TimeTrackingReportDataRowBase {
  work_type_id?: string;
}

export interface ProjectTeamTimeTrackingReportDataRow
  extends TimeTrackingReportDataRowBase {
  project_id?: string;
  contact_id?: string;
  contact_name?: string;
  user_id?: string;
  user: string;
}

export interface TeamTimeTrackingReportDataRow
  extends TimeTrackingReportDataRowBase {}

export type TimeTrackingReportDataRow =
  | ContactTimeTrackingReportDataRow
  | ProjectTimeTrackingReportDataRow
  | WorkTypeTimeTrackingReportDataRow
  | ProjectTeamTimeTrackingReportDataRow[]
  | TeamTimeTrackingReportDataRow;

export interface TimeTrackingReportDataBase {
  billable_hours: number;
  unbillable_hours: number;
  hours: number;
  billable_cost_amount: number;
  billable_amount: number;
  unbillable_cost_amount: number;
  unbillable_amount: number;
  uninvoiced_amount: number;
  net_amount: number;
}

export interface ContactTimeTrackingReportData
  extends TimeTrackingReportDataBase {
  type: TimeTrackingViewReportType.CLIENT;
  entries: ContactTimeTrackingReportDataRow[];
}
export interface ProjectTimeTrackingReportData
  extends TimeTrackingReportDataBase {
  type: TimeTrackingViewReportType.PROJECT;
  entries: ProjectTimeTrackingReportDataRow[];
  budget?: string | number;
}

export interface WorkTypeTimeTrackingReportData
  extends TimeTrackingReportDataBase {
  type: TimeTrackingViewReportType.WORK_TYPE;
  entries: WorkTypeTimeTrackingReportDataRow[];
}

export interface ProjectTeamTimeTrackingReportData
  extends TimeTrackingReportDataBase {
  type: TimeTrackingViewReportType.PROJECT_TEAM;
  entries: Array<any[]>;
}

export interface TeamTimeTrackingReportData extends TimeTrackingReportDataBase {
  type: TimeTrackingViewReportType.TEAM;
  entries: TeamTimeTrackingReportDataRow[];
}

export type TimeTrackingReportData =
  | ContactTimeTrackingReportData
  | ProjectTimeTrackingReportData
  | WorkTypeTimeTrackingReportData
  | ProjectTeamTimeTrackingReportData
  | TeamTimeTrackingReportData;

export enum NavigationMenuListType {
  MAIN = "main",
  CHILD = "child",
}

export enum NavigationMenuItemPage {
  // i18n.t('NavigationMenuItemPage::dashboard')
  DASHBOARD = "dashboard",
  // i18n.t('NavigationMenuItemPage::calendar')
  CALENDAR = "calendar",
  // i18n.t('NavigationMenuItemPage::tasks')
  TASKS = "tasks",
  // i18n.t('NavigationMenuItemPage::contacts')
  CONTACTS = "contacts",
  // i18n.t('NavigationMenuItemPage::sequences')
  SEQUENCES = "sequences",
  // i18n.t('NavigationMenuItemPage::deals')
  DEALS = "deals",
  // i18n.t('NavigationMenuItemPage::projects')
  PROJECTS = "projects",
  // i18n.t('NavigationMenuItemPage::track')
  TIME_TRACKING = "track",
  // i18n.t('NavigationMenuItemPage::proposals')
  PROPOSALS = "proposals",
  // i18n.t('NavigationMenuItemPage::invoices')
  INVOICES = "invoices",
  // i18n.t('NavigationMenuItemPage::contracts')
  CONTRACTS = "contracts",
  // i18n.t('NavigationMenuItemPage::expenses')
  EXPENSES = "expenses",
  // i18n.t('NavigationMenuItemPage::bank')
  BANK = "bank",
  // i18n.t('NavigationMenuItemPage::payments')
  PAYMENTS = "payments",
  // i18n.t('NavigationMenuItemPage::accountant')
  ACCOUNTANT = "accountant",
  // i18n.t('NavigationMenuItemPage::products')
  PRODUCTS = "products",
  // i18n.t('NavigationMenuItemPage::forms')
  FORMS = "forms",
  // i18n.t('NavigationMenuItemPage::scheduling')
  SCHEDULING = "scheduling",
  // i18n.t('NavigationMenuItemPage::files')
  FILES = "files",
  // i18n.t('NavigationMenuItemPage::reporting')
  REPORTING = "reporting",
  // i18n.t('NavigationMenuItemPage::inbox')
  INBOX = "inbox",
  // i18n.t('NavigationMenuItemPage::widgets')
  WIDGETS = "widgets",
  // i18n.t('NavigationMenuItemPage::help_centers')
  HELP_CENTERS = "help_centers",
  // i18n.t('NavigationMenuItemPage::news_centers')
  NEWS_CENTERS = "news_centers",
}

export enum NavigationMenuItemType {
  GROUP = "group",
  PAGE = "page",
  LINK = "link",
  DIVIDER = "divider",
}

export interface NavigationMenuItemBase {
  position?: number;
}

export interface GroupNavigationMenuItem extends NavigationMenuItemBase {
  type?: NavigationMenuItemType.GROUP;
  label?: string;
  items?: NavigationMenuItem[];
}
export interface PageNavigationMenuItem extends NavigationMenuItemBase {
  type?: NavigationMenuItemType.PAGE;
  page?: NavigationMenuItemPage;
  home?: boolean;
}

export interface LinkNavigationMenuItem extends NavigationMenuItemBase {
  type?: NavigationMenuItemType.LINK;
  label?: string;
  value?: string;
}

export interface DividerNavigationMenuItem extends NavigationMenuItemBase {
  type?: NavigationMenuItemType.DIVIDER;
}

export type NavigationMenuItem =
  | GroupNavigationMenuItem
  | PageNavigationMenuItem
  | LinkNavigationMenuItem
  | DividerNavigationMenuItem;

export enum LedgerItemPaymentMethod {
  // t('LedgerItemPaymentMethod::cash')
  CASH = "cash",
  // t('LedgerItemPaymentMethod::bank_transfer')
  BANK_TRANSFER = "bank_transfer",
}

export interface LedgerItemPayment {
  id?: string;
  amount?: number;
  payment_method?: "cash" | "bank_transfer";
  currency?: string;
  executed_at?: string | Date;
  details?: string;
  uid?: string;
  ledger_item_id?: string;
}

export interface UnpaidClaim {
  claim_id: string;
  claim_status: string;
  claim_status_explanation: string;
  claim_unpaid_status: number;
  claim_unpaid_status_explanation: string;
  payment_error: boolean;
  payment_tried: boolean;
  payment_url: string;
  calculations: {
    table: {
      amount_due: string;
      amount_due_no_interest: string;
      bailiff_pay: string;
      capped: string;
      excl: string;
      full_tpoay: string;
      receive_extra: number;
      tax: string;
      topay: string;
    };
  };
}

export interface Payment {
  id?: string;
  remittance_information?: string;
  remittance_information_type?: RemittanceInformationType;
  currency?: string;
  amount?: number | string;
  creditor_name?: string;
  creditor_account?: string;
  creditor_account_type?: string;
  notes?: string;
  payment_initiation?: PaymentInitiation;
  payment_initiation_id?: string;
  suggested_execution_date?: string | Date;
  execution_date?: string | Date;
  created_at?: string | Date;
}

export type PaymentProperty = keyof Payment;

export type PaymentColumnProperty = keyof Pick<Payment, "id">;
export const PaymentColumns: PaymentColumnProperty[] = [];

export type PaymentFilterProperty = keyof Pick<
  Payment & { status: PaymentInitiationStatus },
  | "creditor_name"
  | "creditor_account"
  | "status"
  | "remittance_information"
  | "execution_date"
  | "amount"
  | "created_at"
>;

export const PaymentFilters: PaymentFilterProperty[] = [
  "creditor_name",
  "creditor_account",
  "status",
  "remittance_information",
  "execution_date",
  "amount",
  "created_at",
];
export type PaymentFilter = ResourceFilter<PaymentFilterProperty>;

export const enum PaymentInitiationStatus {
  // t('PaymentInitiationStatus::draft')
  DRAFT = "draft",
  // t('PaymentInitiationStatus::unsigned')
  UNSIGNED = "unsigned",
  // t('PaymentInitiationStatus::signed')
  SIGNED = "signed",
}

export interface PaymentInitiation {
  id?: string;
  reference?: string;
  status?: PaymentInitiationStatus;
  notes?: string;
  uuid?: string;
  sign_redirect_url?: string;
  execution_date?: string;
  created_at?: string | Date;
  account_id?: string;
  account?: Account;
  payments?: Payment[];
}

export interface PaymentInitiationIntegrationMetadata {
  integration_enabled: boolean;
  payments_activation_requested: boolean;
  payments_activated: boolean;
}

export interface PaymentInitiationForm {
  payment_initiation: PaymentInitiation;
  payment_initiation_metadata: PaymentInitiationIntegrationMetadata;
}

export interface BizzeyInvoice {
  id?: string;
  invoice_id?: string;
  customer_id?: string;
  workspace_Id?: string;
  created_at?: string;
}

export interface Deal {
  id?: string;
  name?: string;
  number?: string;
  notes?: string;
  amount?: number;
  currency?: string;
  status?: DealStatus;
  lost_reason?: string;
  contact?: Contact;
  contact_id?: string;
  project?: Project;
  project_id?: string;
  due_on?: string | Date;
  success_rate?: number;
  deal_stage?: DealStage;
  deal_stage_id?: string;
  assignee?: User;
  assignee_id?: string;
  position?: number;
  updated_at?: string | Date;
  created_at?: string | Date;
}

export enum DealStageAction {
  // i18n.t('DealStageAction::event')
  EVENT = "event",
  // i18n.t('DealStageAction::email')
  EMAIL = "email",
  // i18n.t('DealStageAction::call')
  CALL = "call",
  // i18n.t('DealStageAction::appointment')
  APPOINTMENT = "appointment",
  // i18n.t('DealStageAction::project')
  PROJECT = "project",
  // i18n.t('DealStageAction::task')
  TASK = "task",
}

export enum DealStatus {
  // i18n.t('DealStatus::open')
  OPEN = "open",
  // i18n.t('DealStatus::won')
  WON = "won",
  // i18n.t('DealStatus::lost')
  LOST = "lost",
}

export type DealProperty = keyof Deal;

export type DealColumnProperty = keyof Pick<
  Deal,
  | "id"
  | "name"
  | "number"
  | "notes"
  | "amount"
  | "currency"
  | "status"
  | "contact"
  | "project"
  | "due_on"
  | "deal_stage"
  | "assignee"
  | "created_at"
>;

export const DealColumns: DealColumnProperty[] = [
  "id",
  "name",
  "number",
  "notes",
  "amount",
  "currency",
  "status",
  "contact",
  "project",
  "due_on",
  "deal_stage",
  "assignee",
  "created_at",
];

export interface DealStage {
  id?: string;
  name?: string;
  status?: DealStatus;
  success_rate?: number;
  inactivity_alert?: number;
  action?: DealStageAction;
  position?: number;
  created_at?: string | Date;
}

export enum DealViewActionType {
  CALENDAR_EVENT = "calendar_event",
  TASK = "task",
}

export interface DealViewActionBase {
  type: DealViewActionType;
}

export interface DealViewCalendarEventAction extends DealViewActionBase {
  type: DealViewActionType.CALENDAR_EVENT;
  resource: CalendarEvent;
}
export interface DealViewTaskAction extends DealViewActionBase {
  type: DealViewActionType.TASK;
  resource: Task;
}

export enum LedgerItemExportType {
  // i18n.t('LedgerItemExportType::xlsx')
  EXCEL = "xlsx",
  // i18n.t('LedgerItemExportType::csv')
  CSV = "csv",
  // i18n.t('LedgerItemExportType::pdf')
  PDF = "pdf",
  // i18n.t('LedgerItemExportType::ubl')
  UBL = "ubl",
}

export interface ExportLedgerItemParams {
  type: LedgerItemExportType;
  start: string;
  end: string;
}

export enum ExpenseExportType {
  // i18n.t('ExpenseExportType::xlsx')
  EXCEL = "xlsx",
  // i18n.t('ExpenseExportType::csv')
  CSV = "csv",
  // i18n.t('ExpenseExportType::receipt')
  RECEIPT = "receipt",
}

export interface ExportExpenseParams {
  type: ExpenseExportType;
  start: string;
  end: string;
}

export enum ExportTimePeriod {
  // i18n.t('ExportTimePeriod::all')
  ALL = "all",
  // i18n.t('ExportTimePeriod::current_month')
  CURRENT_MONTH = "current_month",
  // i18n.t('ExportTimePeriod::previous_month')
  PREVIOUS_MONTH = "previous_month",
  // i18n.t('ExportTimePeriod::current_quarter')
  CURRENT_QUARTER = "current_quarter",
  // i18n.t('ExportTimePeriod::previous_quarter')
  PREVIOUS_QUARTER = "previous_quarter",
  // i18n.t('ExportTimePeriod::current_year')
  CURRENT_YEAR = "current_year",
  // i18n.t('ExportTimePeriod::previous_year')
  PREVIOUS_YEAR = "previous_year",
  // i18n.t('ExportTimePeriod::custom')
  CUSTOM = "custom",
}

export interface Pagination {
  page: number;
  perPage: number;
  pageCount: number;
}

export interface WorkType {
  id?: string;
  name?: string;
  color?: string;
  billable?: boolean;
  hourly_rate?: number;
  day_rate?: number;
  multiplier?: number;
  position?: number;
  workspace_id?: string;
}

export enum RateType {
  // i18n.t('RateType::user')
  USER = "user",
  // i18n.t('RateType::work_type')
  WORK_TYPE = "work_type",
  // i18n.t('RateType::fixed')
  FIXED = "fixed",
}

export enum CalendarIntegrationType {
  GOOGLE = "google",
  MICROSOFT = "outlook",
}

export interface CalendarIntegration {
  id?: string;
  type?: CalendarIntegrationType;
  access_token?: string;
  refresh_token?: string;
  config?: object;
}

export interface GoogleCalendar extends CalendarIntegration {
  type: CalendarIntegrationType.GOOGLE;
}

export interface PeppolSearchParams {
  // Generic query term. It queries all fields and the results equal the ones that can be obtained when using the simple search. The query term is split into pieces internally and subwords may be found.
  q?: string;
  // Searches for exact matches in the Peppol participant identifier field (the identifier scheme must be part of the value).
  participant?: string;
  // Searches for partial matches in business entity names.
  name?: string;
  // Searches for exact matches in business entity country codes.
  country?: string;
  // Defines the 0-based index for the result page to be returned. If not provided, the first page is returned. By default only 20 entries are returned and this entry can be used to browse the results. Use this in combination with resultPageCount to define the number of results.
  resultPageIndex?: string | number;
  // Defines the number of items to be returned per page. If not provided 20 entries are returned. Use this in combination with resultPageIndex to define the number of results.
  resultPageCount?: string | number;
}

export interface PeppolParticipant {
  participantID: {
    scheme: string;
    value: string;
  };
  docTypes: Array<{
    scheme: string;
    value: string;
  }>;
  entities: Array<{
    name: Array<{
      name: string;
    }>;
    countryCode: string;
    websites?: string[];
    additionalInfo?: string;
    identifiers?: Array<{
      scheme: string;
      value: string;
    }>;
    regDate?: string | Date;
  }>;
}

export interface PeppolSearchResult {
  version: string;
  "total-result-count": number;
  "used-result-count": number;
  "result-page-index": number;
  "result-page-count": number;
  "first-result-index": number;
  "last-result-index": number;
  "query-terms": string;
  "creation-dt": string;
  matches: PeppolParticipant[];
}

export enum ContactViewActionType {
  CALENDAR_EVENT = "calendar_event",
  TASK = "task",
}

export interface ContactViewActionBase {
  type: ContactViewActionType;
}

export interface ContactViewCalendarEventAction extends ContactViewActionBase {
  type: ContactViewActionType.CALENDAR_EVENT;
  resource: CalendarEvent;
}
export interface ContactViewTaskAction extends ContactViewActionBase {
  type: ContactViewActionType.TASK;
  resource: Task;
}

export interface FinancialYear {
  id?: string;
  name?: string;
  start_date?: string;
  end_date?: string;
}

export interface Account {
  id?: string;
  name?: string;
  reference?: string;
  currency?: string;
  financial_institution?: string;
  balance?: number;
  reauthorize_at?: string | Date;
  created_at?: string | Date;
}

export type AccountColumnProperty = keyof Pick<Account, "id">;
export const AccountColumns: AccountColumnProperty[] = [];

export type AccountFilterProperty = keyof Pick<
  Account,
  | "name"
  | "financial_institution"
  | "reference"
  | "balance"
  | "currency"
  | "created_at"
>;

export const AccountFilters: AccountFilterProperty[] = [
  "name",
  "financial_institution",
  "reference",
  "balance",
  "currency",
  "created_at",
];
export type AccountFilter = ResourceFilter<AccountFilterProperty>;

export interface Transaction {
  id?: string;
  counterpart_name?: string;
  counterpart_account_number?: string;
  description?: string;
  additional_information?: string;
  amount?: string;
  linked_amount?: string;
  currency?: string;
  remittance_information?: string;
  remittance_information_type?: RemittanceInformationType;
  provider?: string;
  uid?: string;
  execution_time?: string;
  notes?: string;
  verified?: boolean;
  manually_verified?: boolean;
  payment_ids?: string[];
  ledger_item_ids?: string[];
  expense_ids?: string[];
  account_id?: string;
  account?: Account;
  created_at?: string | Date;
}

export type TransactionProperty = keyof Transaction;

export type TransactionColumnProperty = keyof Pick<Transaction, "id">;
export const TransactionColumns: TransactionColumnProperty[] = [];

export type TransactionFilterProperty = keyof Pick<
  Transaction,
  | "verified"
  | "account_id"
  | "counterpart_name"
  | "counterpart_account_number"
  | "remittance_information"
  | "execution_time"
  | "amount"
  | "currency"
  | "created_at"
>;

export const TransactionFilters: TransactionFilterProperty[] = [
  "verified",
  "account_id",
  "counterpart_name",
  "counterpart_account_number",
  "remittance_information",
  "execution_time",
  "amount",
  "currency",
  "created_at",
];
export type TransactionFilter = ResourceFilter<TransactionFilterProperty>;

export interface Playbook {
  id?: string;
  name?: string;
  workspace_id?: string;
  content_blocks?: ContentBlock[];
  created_at?: string;
}

export enum PlaybookableType {
  CONTACT = "Contact",
  TASK = "Task",
}

export interface PlaybookSubmission {
  id?: string;
  playbook_id?: string;
  playbookable_id?: string;
  playbookable_type?: PlaybookableType;
  answers?: PlaybookSubmissionAnswer[];
}

export interface PlaybookSubmissionAnswer {
  id?: string;
  notes?: string;
  selected_answers?: string[];
  question_id?: string;
  playbook_submission_id?: string;
}

export enum PlaybookChannelEventType {
  PLAYBOOK_CREATE = "PLAYBOOK_CREATE",
  PLAYBOOK_UPDATE = "PLAYBOOK_UPDATE",
  PLAYBOOK_DELETE = "PLAYBOOK_DELETE",

  CONTENT_BLOCK_CREATE = "CONTENT_BLOCK_CREATE",
  CONTENT_BLOCK_UPDATE = "CONTENT_BLOCK_UPDATE",
  CONTENT_BLOCK_DELETE = "CONTENT_BLOCK_DELETE",
}

export type PlaybookChannelEvent =
  | PlaybookChannelCreatePlaybookEvent
  | PlaybookChannelUpdatePlaybookEvent
  | PlaybookChannelDeletePlaybookEvent
  | PlaybookChannelCreateContentBlockEvent
  | PlaybookChannelUpdateContentBlockEvent
  | PlaybookChannelDeleteContentBlockEvent;

export interface PlaybookChannelEventBase {
  type: PlaybookChannelEventType;
  data: object;
}

export interface PlaybookChannelCreatePlaybookEvent
  extends PlaybookChannelEventBase {
  type: PlaybookChannelEventType.PLAYBOOK_CREATE;
  data: { playbook: Playbook };
}

export interface PlaybookChannelUpdatePlaybookEvent
  extends PlaybookChannelEventBase {
  type: PlaybookChannelEventType.PLAYBOOK_UPDATE;
  data: { playbook: Playbook };
}

export interface PlaybookChannelDeletePlaybookEvent
  extends PlaybookChannelEventBase {
  type: PlaybookChannelEventType.PLAYBOOK_DELETE;
  data: { playbook_id: string };
}

export interface PlaybookChannelCreateContentBlockEvent
  extends PlaybookChannelEventBase {
  type: PlaybookChannelEventType.CONTENT_BLOCK_CREATE;
  data: { content_block: ContentBlock };
}

export interface PlaybookChannelUpdateContentBlockEvent
  extends PlaybookChannelEventBase {
  type: PlaybookChannelEventType.CONTENT_BLOCK_UPDATE;
  data: { content_block: ContentBlock };
}

export interface PlaybookChannelDeleteContentBlockEvent
  extends PlaybookChannelEventBase {
  type: PlaybookChannelEventType.CONTENT_BLOCK_DELETE;
  data: { content_block_id: string };
}

export interface UBLExtractionBase {
  type?: "invoice" | "credit_note";
  number?: string;
  issue_date?: string;
  currency?: string;
  supplier?: {
    endpoint_scheme?: string;
    endpoint_id?: string;
    party_id?: string;
    name?: string;
    company_id?: string;
    vat_number?: string;
    legal_name?: string;
    address?: {
      street?: string;
      city?: string;
      postal?: string;
      country_code?: string;
    };
  };
  customer?: {
    endpoint_scheme?: string;
    endpoint_id?: string;
    party_id?: string;
    name?: string;
    vat_number?: string;
    company_id?: string;
    legal_name?: string;
    address?: {
      street?: string;
      city?: string;
      postal?: string;
      country_code?: string;
    };
  };
  payment_details?: {
    id?: string;
    account_id?: string;
    account_name?: string;
    account_swift?: string;
    terms?: string;
  };
  total_exclusive?: string | number;
  total_inclusive?: string | number;
  line_items?: {
    id: string;
    description?: string;
    quantity?: string | number;
    tax_rate?: string | number;
    exclusive_amount?: string | number;
    tax_amount?: string | number;
    total_amount?: string | number;
  }[];
  attachments?: string[];
}

export interface UBLInvoiceExtractionData extends UBLExtractionBase {
  type: "invoice";
  due_date?: string;
}

export interface UBLCreditnoteExtractionData extends UBLExtractionBase {
  type: "credit_note";
}

export type UBLData = UBLInvoiceExtractionData | UBLCreditnoteExtractionData;

export enum SettingsEmailTemplate {
  // i18n.t(`EmailTemplate::order_form`)
  ORDER_FORM = "order_form",
  // i18n.t(`EmailTemplate::delivery_note`)
  DELIVERY_NOTE = "delivery_note",
  // i18n.t(`EmailTemplate::quote`)
  QUOTE = "quote",
  // i18n.t(`EmailTemplate::pro_forma_invoice`)
  PRO_FORMA_INVOICE = "pro_forma_invoice",
  // i18n.t(`EmailTemplate::invoice`)
  INVOICE = "invoice",
  // i18n.t(`EmailTemplate::invoice_reminder`)
  INVOICE_REMINDER = "invoice_reminder",
  // i18n.t(`EmailTemplate::invoice_paid`)
  INVOICE_PAID = "invoice_paid",
  // i18n.t(`EmailTemplate::credit_note`)
  CREDIT_NOTE = "credit_note",
  // i18n.t(`EmailTemplate::proposal`)
  PROPOSAL = "proposal",
  // i18n.t(`EmailTemplate::contract`)
  CONTRACT = "contract",
}

export interface Transfer {
  id?: string;
  name?: string;
  expires_at?: string;
  workspace_id?: string;
  created_at?: string;
  files: ActiveStorage.Blob[];
}

export interface Email {
  id?: string;
  from?: EmailHeader;
  to?: EmailHeader[];
  cc?: EmailHeader[];
  subject?: string;
  body?: string;
  raw_text?: string;
  raw_html?: string;
  raw_body?: string;
  attachments?: any[];
  created_at?: string;
}

export interface EmailHeader {
  token?: string;
  host?: string;
  email?: string;
  full?: string;
  name?: string;
}

export enum ActivityType {
  CREATION = "creation",
  NOTE = "note",
  EMAIL = "email",
  CALENDAR_EVENT = "calendar_event",
  TASK = "task",
  OFFER_SIGNED = "offer_signed",
  INVOICE_PAID = "invoice_paid",
  LEDGER_ITEM_SEEN = "ledger_item_seen",
  CALL = "call",
  ENROLL_SEQUENCE = "enroll_sequence",
  UNENROLL_SEQUENCE = "unenroll_sequence",
}

export enum ActivityTrackableType {
  CLIENT = "Contact",
  PROJECT = "Project",
  DEAL = "Deal",
}

interface ActivityBase {
  id?: string;
  type?: ActivityType;
  trackable_type?: ActivityTrackableType;
  trackable_id?: string;
  trackable?: any;
  model_type?: string;
  model_id?: string;
  model?: any;
  owner_type?: string;
  owner_id?: string;
  owner?: any;
  recipient_type?: string;
  recipient_id?: string;
  recipient?: any;
  data: Object;
  workspace_id?: string;
  created_at?: string;
}

interface CreatedActivity extends ActivityBase {
  type: ActivityType.CREATION;
  data: {};
}

interface NoteActivity extends ActivityBase {
  type: ActivityType.NOTE;
  data: { note: string };
}

interface EmailActivity extends ActivityBase {
  type: ActivityType.EMAIL;
  model: Email;
  model_type: "Email";
}

interface CalendarEventActivity extends ActivityBase {
  type: ActivityType.CALENDAR_EVENT;
  model: CalendarEvent;
  model_type: "CalendarEvent";
}

interface TaskActivity extends ActivityBase {
  type: ActivityType.TASK;
  model: Task;
  model_type: "Task";
}

interface InvoicePaidActivity extends ActivityBase {
  type: ActivityType.INVOICE_PAID;
  model: LedgerItem;
  model_type: "LedgerItem";
}

interface LedgerItemSeenActivity extends ActivityBase {
  type: ActivityType.LEDGER_ITEM_SEEN;
  model: LedgerItem;
  model_type: "LedgerItem";
}

interface OfferSignedActivity extends ActivityBase {
  type: ActivityType.OFFER_SIGNED;
  model: LedgerItem;
  model_type: "LedgerItem";
}

interface CallActivity extends ActivityBase {
  type: ActivityType.CALL;
  model: Call;
  model_type: "Call";
}

interface SequenceEnrollmentActivity extends ActivityBase {
  type: ActivityType.ENROLL_SEQUENCE;
  model: Sequence;
  model_type: "Sequence";
}

interface SequenceUnenrollmentActivity extends ActivityBase {
  type: ActivityType.UNENROLL_SEQUENCE;
  model: Sequence;
  model_type: "Sequence";
}

export type Activity =
  | CreatedActivity
  | NoteActivity
  | EmailActivity
  | CalendarEventActivity
  | TaskActivity
  | InvoicePaidActivity
  | LedgerItemSeenActivity
  | OfferSignedActivity
  | CallActivity
  | SequenceEnrollmentActivity
  | SequenceUnenrollmentActivity;

export interface QRCData {
  name: string;
  iban: string;
  remittanceInformationType: RemittanceInformationType;
  remittanceInformation: string;
  amount: number;
  currency: string;
}

export interface TaskTimeTrackingReportDataBase {}

export interface TaskSummaryTimeTrackingReportDataRow
  extends TaskTimeTrackingReportDataBase {
  user_id?: string;
  name: string;
  time_spent?: string;
}

export interface TaskTimesheetTimeTrackingReportDataRow
  extends TaskTimeTrackingReportDataBase {
  user_id?: string;
  user: string;
}

export type TaskTimeTrackingReportDataRow =
  | TaskSummaryTimeTrackingReportDataRow
  | TimeEntry[];

export enum TaskTimeTrackingViewReportType {
  // t('TaskTimeTrackingViewReportType::summary')
  SUMMARY = "summary",
  // t('TaskTimeTrackingViewReportType::timesheet')
  TIMESHEET = "timesheet",
}

export interface TaskSummaryTimeTrackingReportData
  extends TaskTimeTrackingReportDataBase {
  type: TaskTimeTrackingViewReportType.SUMMARY;
  time_estimated: string;
  time_spent: string;
  entries: TaskSummaryTimeTrackingReportDataRow[];
}
export interface TaskTimesheetTimeTrackingReportData
  extends TaskTimeTrackingReportDataBase {
  type: TaskTimeTrackingViewReportType.TIMESHEET;
  time_estimated: string;
  time_spent: string;
  entries: TimeEntry[];
}

export type TaskTimeTrackingReportData =
  | TaskSummaryTimeTrackingReportData
  | TaskTimesheetTimeTrackingReportData;

export interface VATResponse {
  name?: string;
  vat_number?: string;
  company_type?: string;
  street?: string;
  street_number?: string;
  postal?: string;
  city?: string;
  country?: string;
  full_address?: string;
  errors?: any;
}

export interface Document {
  id?: string;
  name?: string;
  description?: string;
  date?: string;
  booked_on?: string;
  created_at?: string;
  attachment?: any;
  attachment_file_name?: string;
  attachment_content_type?: string;
  attachment_file_size?: number;
  attachment_url?: string | null;
  attachment_download_url?: string | null;
  tags?: DocumentTag[];
  tag_ids?: string[];
}

export interface DocumentTag {
  id?: string;
  name?: string;
  type?: string;
}

export interface ExportDocumentParams {
  start: string;
  end: string;
}

export enum FollowUpActionType {
  // i18n.t('FollowUpActionType::call')
  CALL = "call",
  // i18n.t('FollowUpActionType::email')
  EMAIL = "email",
  // i18n.t('FollowUpActionType::todo')
  TODO = "todo",
}

export interface PlannerItem {
  user: User;
  dates: PlannerDate[];
}

export interface PlannerDate {
  day: Date | string;
  items: PlannerDateItem[];
  start_time: string;
  end_time: string;
  break_enabled: boolean;
  break_start_time: string;
  break_end_time: string;
  availability: number;
}

export type PlannerDateItem = CalendarEventPlannerItem | PlannedTaskPlannerItem;

interface BasePlannerEventItem {
  id: string;
  title?: string;
  type: "calendar_event" | "planned_task";
  start_at: string | Date;
  end_at: string | Date;
  duration: number;
}

interface CalendarEventPlannerItem extends BasePlannerEventItem {
  type: "calendar_event";
}

interface PlannedTaskPlannerItem extends BasePlannerEventItem {
  type: "planned_task";
  task_id: string;
}

export type PlannerData = PlannerItem[];

export interface PlannedTask {
  id?: string;
  start_at?: string | Date;
  end_at?: string | Date;
  duration?: number;
  task_id?: string;
  user?: User;
  user_id?: string;
  task?: Task;
  created_at?: string | Date;
}

export interface ActiveStorageBlob extends ActiveStorage.Blob {
  id: string;
}

export enum PushNotificationDataType {
  CALL = "call",
}

export interface PushNotificationDataBase {
  type: PushNotificationDataType;
}

export interface CallPushNotificationPayload extends PushNotificationDataBase {
  type: PushNotificationDataType.CALL;
  telephone_number: string;
}

export type PushNotificationData = CallPushNotificationPayload;

export enum CallOutcome {
  // i18n.t('CallOutcome::busy')
  BUSY = "busy",
  // i18n.t('CallOutcome::connected')
  CONNECTED = "connected",
  // i18n.t('CallOutcome::left_live_message')
  LEFT_LIVE_MESSAGE = "left_live_message",
  // i18n.t('CallOutcome::left_voicemail')
  LEFT_VOICEMAIL = "left_voicemail",
  // i18n.t('CallOutcome::no_answer')
  NO_ANSWER = "no_answer",
  // i18n.t('CallOutcome::wrong_number')
  WRONG_NUMBER = "wrong_number",
}

export enum CallDirection {
  // i18n.t('CallDirection::inbound')
  INBOUND = "inbound",
  // i18n.t('CallDirection::outbound')
  OUTBOUND = "outbound",
}

export interface Call {
  id?: string;
  outcome?: CallOutcome;
  direction?: CallDirection;
  datetime?: string | Date;
  notes?: string;
  contact_id?: string;
  deal_id?: string;
  created_at?: string | Date;
}

export interface EmailTemplate {
  id?: string;
  name?: string;
  subject?: string;
  body?: string;
  attachment_ids?: string[];
  attachments?: ActiveStorageBlob[];
  user_id?: string;
  created_at?: string;
}

export interface SequenceMetadata {
  scheduled?: number;
  active?: number;
  paused?: number;
  finished?: number;
}

export interface Sequence {
  id?: string;
  name?: string;
  active?: boolean;
  business_days_only?: boolean;
  steps?: SequenceStep[];
}

export type SequenceProperty = keyof Sequence;

export type SequenceColumnProperty = keyof Pick<
  Sequence,
  "name" | "active" | "business_days_only"
>;

export const SequenceColumns: SequenceColumnProperty[] = [
  "name",
  "active",
  "business_days_only",
];

export enum SequenceStepType {
  AUTOMATED_EMAIL = "automated_email",
  MANUAL_EMAIL = "manual_email",
  CALL = "call",
  TASK = "task",
}

export interface SequenceStepBase {
  id?: string;
  type?: SequenceStepType;
  delay?: number;
  sequence_id?: string;
  position?: number;
}

export interface SequenceStepEmail {
  id?: string;
  active?: boolean;
  subject?: string;
  body?: string;
  send_counter?: number;
  open_counter?: number;
  click_counter?: number;
}

export interface AutomatedEmailSequenceStep extends SequenceStepBase {
  type: SequenceStepType.AUTOMATED_EMAIL;
  emails?: SequenceStepEmail[];
}

export interface ManualEmailSequenceStep extends SequenceStepBase {
  type: SequenceStepType.MANUAL_EMAIL;
  name?: string;
  description?: string;
  created_counter?: number;
  completed_counter?: number;
}

export interface CallSequenceStep extends SequenceStepBase {
  type: SequenceStepType.CALL;
  name?: string;
  description?: string;
  created_counter?: number;
  completed_counter?: number;
  playbook_id?: string;
}

export interface TaskSequenceStep extends SequenceStepBase {
  type: SequenceStepType.TASK;
  name?: string;
  description?: string;
  created_counter?: number;
  completed_counter?: number;
}

export type SequenceStep =
  | AutomatedEmailSequenceStep
  | ManualEmailSequenceStep
  | CallSequenceStep
  | TaskSequenceStep;

export interface SequenceStepTypeInfo {
  type: SequenceStepType;
  icon: IconTypes;
  title: string;
  description: string;
  color: string;
  backgroundColor: string;
}

export enum SequenceChannelEventType {
  SEQUENCE_CREATE = "SEQUENCE_CREATE",
  SEQUENCE_UPDATE = "SEQUENCE_UPDATE",
  SEQUENCE_DELETE = "SEQUENCE_DELETE",

  SEQUENCE_STEP_CREATE = "SEQUENCE_STEP_CREATE",
  SEQUENCE_STEP_UPDATE = "SEQUENCE_STEP_UPDATE",
  SEQUENCE_STEP_DELETE = "SEQUENCE_STEP_DELETE",
}

export type SequenceChannelEvent =
  | SequenceChannelCreateSequenceEvent
  | SequenceChannelUpdateSequenceEvent
  | SequenceChannelDeleteSequenceEvent
  | SequenceChannelCreateSequenceStepEvent
  | SequenceChannelUpdateSequenceStepEvent
  | SequenceChannelDeleteSequenceStepEvent;

export interface SequenceChannelEventBase {
  type: SequenceChannelEventType;
  data: object;
}

export interface SequenceChannelCreateSequenceEvent
  extends SequenceChannelEventBase {
  type: SequenceChannelEventType.SEQUENCE_CREATE;
  data: { sequence: Sequence };
}

export interface SequenceChannelUpdateSequenceEvent
  extends SequenceChannelEventBase {
  type: SequenceChannelEventType.SEQUENCE_UPDATE;
  data: { sequence: Sequence };
}

export interface SequenceChannelDeleteSequenceEvent
  extends SequenceChannelEventBase {
  type: SequenceChannelEventType.SEQUENCE_DELETE;
  data: { sequence_id: string };
}

export interface SequenceChannelCreateSequenceStepEvent
  extends SequenceChannelEventBase {
  type: SequenceChannelEventType.SEQUENCE_STEP_CREATE;
  data: { sequence_step: SequenceStep };
}

export interface SequenceChannelUpdateSequenceStepEvent
  extends SequenceChannelEventBase {
  type: SequenceChannelEventType.SEQUENCE_STEP_UPDATE;
  data: { sequence_step: SequenceStep };
}

export interface SequenceChannelDeleteSequenceStepEvent
  extends SequenceChannelEventBase {
  type: SequenceChannelEventType.SEQUENCE_STEP_DELETE;
  data: { sequence_step_id: string };
}

export enum SequenceEnrollmentStatus {
  // i18n.t('SequenceEnrollmentStatus::scheduled')
  SCHEDULED = "scheduled",
  // i18n.t('SequenceEnrollmentStatus::in_progress')
  IN_PROGRESS = "in_progress",
  // i18n.t('SequenceEnrollmentStatus::paused')
  PAUSED = "paused",
  // i18n.t('SequenceEnrollmentStatus::finished')
  FINISHED = "finished",
  // i18n.t('SequenceEnrollmentStatus::error')
  ERROR = "error",
}

export interface SequenceEnrollment {
  id?: string;
  contact?: Contact;
  contact_id?: string;
  status?: SequenceEnrollmentStatus;
  created_at?: string | Date;
  sequence_id?: string;
  step_id?: string;
}

export interface NumberVariables {
  year: string;
  year_short: string;
  month: string;
  month_short: string;
  month_number: string;
  day: string;
  day_short: string;
}

export type HelpCenterTranslateableFields = {
  title?: string;
  description?: string;
  welcome_message?: string;
  featured_articles_title?: string;
};

export enum HelpCenterPage {
  // i18n.t('HelpCenterPage::homepage')
  HOMEPAGE = "homepage",
  // i18n.t('HelpCenterPage::collection')
  COLLECTION = "collection",
  // i18n.t('HelpCenterPage::article')
  ARTICLE = "article",
}

export interface HelpCenterLink {
  locale: PublicLocale;
  label: string;
  url: string;
}

export interface HelpCenter {
  id?: string;
  name?: string;
  business_name?: string;
  enabled?: boolean;
  locale?: string;
  url?: string;
  supported_locales?: PublicLocale[];
  slug?: string;
  custom_domain?: string;
  google_analytics_id?: string;
  favicon?: any;
  favicon_url?: string;
  open_graph_image?: any;
  open_graph_image_url?: string;
  background_color?: string;
  action_color?: string;
  show_article_authors?: boolean;
  logo_url?: string;
  logo?: any;
  header_page_title?: string;
  header_links?: HelpCenterLink[];
  header_background_color?: string;
  header_text_color?: string;
  header_background_fade?: boolean;
  header_height?: string | number;
  header_image?: any;
  header_image_url?: string;
  collection_descriptions_enabled?: boolean;
  table_of_contents_enabled?: boolean;
  related_articles_enabled?: boolean;
  translations?: MobilityTranslations<HelpCenterTranslateableFields>;
  created_at?: string;
}

export type HelpCenterProperty = keyof HelpCenter;

export type HelpCenterColumnProperty = keyof Pick<HelpCenter, "id" | "name">;
export const HelpCenterColumns: HelpCenterColumnProperty[] = [];

export type HelpCenterFilterProperty = keyof Pick<
  HelpCenter,
  "name" | "enabled" | "created_at"
>;

export const HelpCenterFilters: HelpCenterFilterProperty[] = [
  "name",
  "enabled",
  "created_at",
];
export type HelpCenterFilter = ResourceFilter<HelpCenterFilterProperty>;

export enum BrowserSize {
  // i18n.t('BrowserSize::desktop')
  DESKTOP = "desktop",
  // i18n.t('BrowserSize::tablet')
  TABLET = "tablet",
  // i18n.t('BrowserSize::mobile')
  MOBILE = "mobile",
}

export type ArticleCollectionTranslateableFields = {
  title?: string;
  slug?: string;
  description?: string;
};

export interface ArticleCollection {
  id?: string;
  icon?: string;
  articles_count?: number;
  authors_count?: number;
  help_center_id?: string;
  parent_id?: string;
  translations?: MobilityTranslations<ArticleCollectionTranslateableFields>;
  article_collection?: ArticleCollection;
  article_collections?: ArticleCollection[];
  position?: number;
  created_at?: string;
}

export enum ArticleCollectionIconCategory {
  // i18n.t('ArticleCollectionIconCategory::arrow_symbols')
  ARROW_SYMBOLS = "arrow_symbols",
  // i18n.t('ArticleCollectionIconCategory::business_finance')
  BUSINESS_FINANCE = "business_finance",
  // i18n.t('ArticleCollectionIconCategory::charts')
  CHARTS = "charts",
  // i18n.t('ArticleCollectionIconCategory::communication')
  COMMUNICATION = "communication",
  // i18n.t('ArticleCollectionIconCategory::content')
  CONTENT = "content",
  // i18n.t('ArticleCollectionIconCategory::files_folders')
  FILES_FOLDERS = "files_folders",
  // i18n.t('ArticleCollectionIconCategory::nature')
  NATURE = "nature",
  // i18n.t('ArticleCollectionIconCategory::other')
  OTHER = "other",
  // i18n.t('ArticleCollectionIconCategory::devices')
  DEVICES = "devices",
  // i18n.t('ArticleCollectionIconCategory::people_chats_gestures')
  PEOPLE_CHATS_GESTURES = "people_chats_gestures",
  // i18n.t('ArticleCollectionIconCategory::software')
  SOFTWARE = "software",
}

export interface ArticleCollectionIcon {
  id?: string;
  name?: string;
  category?: ArticleCollectionIconCategory;
  url?: string;
}

export interface HelpCenterArticleCollection extends ArticleCollection {
  article_collection?: HelpCenterArticleCollection;
  article_collections?: HelpCenterArticleCollection[];
  articles?: Article[];
}

export type ArticleTranslateableFields = {
  title?: string;
  slug?: string;
  summary?: string;
  content?: string;
};

export interface Author {
  id?: string;
  name?: string;
  email?: string;
  avatar_url?: string;
}

export interface ArticleTag {
  id?: string;
  name?: string;
}

export interface Article {
  id?: string;
  author_id?: string;
  author?: Author;
  collection_id?: string;
  collection?: ArticleCollection;
  position?: number;
  translations?: MobilityTranslations<ArticleTranslateableFields>;
  tags?: ArticleTag[];
  tag_ids?: string[];
  updated_at?: string;
  created_at?: string;
}

export interface FeaturedArticle {
  id?: string;
  article_id?: string;
  article?: Article;
  help_center_id?: string;
  help_center?: HelpCenter;
  position?: number;
}

export interface HelpCenterArticle extends Article {
  collection?: HelpCenterArticleCollection;
}

export enum HelpCenterTreeModelType {
  ARTICLE = "article",
  COLLECTION = "collection",
  ADD_ARTICLE = "add_article",
}
export interface HelpCenterTreeDataBase {
  type: HelpCenterTreeModelType;
  children?: HelpCenterTreeData[];
}

export interface HelpCenterTreeDataArticle extends HelpCenterTreeDataBase {
  type: HelpCenterTreeModelType.ARTICLE;
  model: Article;
}

export interface HelpCenterTreeDataArticleCollection
  extends HelpCenterTreeDataBase {
  type: HelpCenterTreeModelType.COLLECTION;
  model: ArticleCollection;
}

export interface HelpCenterTreeDataAddArticle extends HelpCenterTreeDataBase {
  type: HelpCenterTreeModelType.ADD_ARTICLE;
  model: any;
}

export type HelpCenterTreeData =
  | HelpCenterTreeDataArticle
  | HelpCenterTreeDataArticleCollection
  | HelpCenterTreeDataAddArticle;

export interface HelpCenterTheme {
  colors: {
    body: string;
    action: string;
  };
}

export enum WidgetClientEventType {
  // When the host window is resized
  WINDOW_RESIZE = "WINDOW_RESIZE",
  // When the widget should navigate to a different space
  NAVIGATE = "NAVIGATE",
  // When the widget should maximize the window
  MAXIMIZE_WINDOW = "MAXIMIZE_WINDOW",
  // When the widget should minimize the window
  MINIMIZE_WINDOW = "MINIMIZE_WINDOW",
  // When the widget should show a new conversation
  SHOW_NEW_CONVERSATION = "SHOW_NEW_CONVERSATION",
  // When the widget should show a specific conversation
  SHOW_CONVERSATION = "SHOW_CONVERSATION",
  // When the widget should show a specific article
  SHOW_ARTICLE = "SHOW_ARTICLE",
  // When the widget should show a specific news item
  SHOW_NEWS = "SHOW_NEWS",
}

export interface WidgetClientEventBase {
  type: WidgetClientEventType;
}

export interface WidgetClientWindowResizeEvent extends WidgetClientEventBase {
  type: WidgetClientEventType.WINDOW_RESIZE;
  width: number;
  height: number;
}

export interface WidgetClientMaximizeWindowEvent extends WidgetClientEventBase {
  type: WidgetClientEventType.MAXIMIZE_WINDOW;
}

export interface WidgetClientMinimizeWindowEvent extends WidgetClientEventBase {
  type: WidgetClientEventType.MINIMIZE_WINDOW;
}

export interface WidgetClientShowSpaceEvent extends WidgetClientEventBase {
  type: WidgetClientEventType.NAVIGATE;
  space: WidgetSpaceType;
}

export interface WidgetClientShowNewConversationEvent
  extends WidgetClientEventBase {
  type: WidgetClientEventType.SHOW_NEW_CONVERSATION;
}

export interface WidgetClientShowConversationEvent
  extends WidgetClientEventBase {
  type: WidgetClientEventType.SHOW_CONVERSATION;
  conversationId: string;
}

export interface WidgetClientShowArticleEvent extends WidgetClientEventBase {
  type: WidgetClientEventType.SHOW_ARTICLE;
  articleId: string;
}

export interface WidgetClientShowNewsEvent extends WidgetClientEventBase {
  type: WidgetClientEventType.SHOW_NEWS;
  newsId: string;
}

export type WidgetClientEvent =
  | WidgetClientWindowResizeEvent
  | WidgetClientMaximizeWindowEvent
  | WidgetClientMinimizeWindowEvent
  | WidgetClientShowSpaceEvent
  | WidgetClientShowNewConversationEvent
  | WidgetClientShowConversationEvent
  | WidgetClientShowArticleEvent
  | WidgetClientShowNewsEvent;

export enum WidgetMessengerEventType {
  // When the widget is initialized
  INITIALIZED = "INITIALIZED",
  // When the messenger frame should be hidden
  CLOSE = "CLOSE",
  // When the messenger frame should be maximized
  MAXIMIZE_WINDOW = "MAXIMIZE_WINDOW",
  // When the messenger frame should be minimized
  MINIMIZE_WINDOW = "MINIMIZE_WINDOW",
  // When the messenger frame should toggle between minimized and maximized
  TOGGLE_WINDOW_SIZE = "TOGGLE_WINDOW_SIZE",
  // When the messenger requests to preview an attachment (needs access to parent window to display preview)
  PREVIEW_ATTACHMENT = "PREVIEW_ATTACHMENT",
}

export interface WidgetMessengerEventBase {
  type: WidgetMessengerEventType;
}

export interface WidgetMessengerInitializedEvent
  extends WidgetMessengerEventBase {
  type: WidgetMessengerEventType.INITIALIZED;
}

export interface WidgetMessengerHideEvent extends WidgetMessengerEventBase {
  type: WidgetMessengerEventType.CLOSE;
}

export interface WidgetMessengerMaximizeWindowEvent
  extends WidgetMessengerEventBase {
  type: WidgetMessengerEventType.MAXIMIZE_WINDOW;
}

export interface WidgetMessengerMinimizeWindowEvent
  extends WidgetMessengerEventBase {
  type: WidgetMessengerEventType.MINIMIZE_WINDOW;
}

export interface WidgetMessengerToggleWindowSizeEvent
  extends WidgetMessengerEventBase {
  type: WidgetMessengerEventType.TOGGLE_WINDOW_SIZE;
}

export interface WidgetMessengerPreviewAttachmentEvent
  extends WidgetMessengerEventBase {
  type: WidgetMessengerEventType.PREVIEW_ATTACHMENT;
  url: string;
}

export type WidgetMessengerEvent =
  | WidgetMessengerInitializedEvent
  | WidgetMessengerHideEvent
  | WidgetMessengerMaximizeWindowEvent
  | WidgetMessengerMinimizeWindowEvent
  | WidgetMessengerToggleWindowSizeEvent
  | WidgetMessengerPreviewAttachmentEvent;

export enum WidgetSpaceType {
  // i18n.t('WidgetSpaceType::home')
  HOME = "home",
  // i18n.t('WidgetSpaceType::conversations')
  CONVERSATIONS = "conversations",
  // i18n.t('WidgetSpaceType::help')
  HELP = "help",
  // i18n.t('WidgetSpaceType::news')
  NEWS = "news",
}

export interface WidgetSpaceBase {
  id?: string;
  type?: WidgetSpaceType;
  enabled?: boolean;
}

export interface WidgetSpaceHome extends WidgetSpaceBase {
  type: WidgetSpaceType.HOME;
}

export interface WidgetSpaceConversations extends WidgetSpaceBase {
  type: WidgetSpaceType.CONVERSATIONS;
}

export interface WidgetSpaceHelp extends WidgetSpaceBase {
  type: WidgetSpaceType.HELP;
}

export interface WidgetSpaceNews extends WidgetSpaceBase {
  type: WidgetSpaceType.NEWS;
}

export type WidgetSpace =
  | WidgetSpaceHome
  | WidgetSpaceConversations
  | WidgetSpaceHelp
  | WidgetSpaceNews;

export enum WidgetCardType {
  // i18n.t('WidgetCardType::new_conversation')
  NEW_CONVERSATION = "new_conversation",
  // i18n.t('WidgetCardType::help_center')
  HELP_CENTER = "help_center",
  // i18n.t('WidgetCardType::news')
  NEWS = "news",
  // i18n.t('WidgetCardType::post')
  POST = "post",
  // i18n.t('WidgetCardType::external_link')
  EXTERNAL_LINK = "external_link",
}

export interface WidgetCardBaseProps {
  widget: Widget;
  locale: PublicLocale;
}

export interface WidgetCardBase {
  id?: string;
  type?: WidgetCardType;
  position?: number;
  translations?: MobilityTranslations<any>;
}

export interface NewConversationWidgetCard extends WidgetCardBase {
  type?: WidgetCardType.NEW_CONVERSATION;
}

export interface HelpCenterWidgetCard extends WidgetCardBase {
  type?: WidgetCardType.HELP_CENTER;
}

export interface NewsWidgetCard extends WidgetCardBase {
  type?: WidgetCardType.NEWS;
}

export interface PostWidgetCard extends WidgetCardBase {
  type?: WidgetCardType.POST;
  translations?: MobilityTranslations<{
    cover_image_url?: string;
    title: string;
    summary: string;
    url?: string;
  }>;
}

export interface ExternalLinksWidgetCard extends WidgetCardBase {
  type?: WidgetCardType.EXTERNAL_LINK;
  external_links?: { label: string; url: string }[];
}

export type WidgetCard =
  | NewConversationWidgetCard
  | HelpCenterWidgetCard
  | NewsWidgetCard
  | PostWidgetCard
  | ExternalLinksWidgetCard;

export enum WidgetTourStepType {
  POST = "post",
  POINTER = "pointer",
  VIDEO_POINTER = "video_pointer",
}

export enum WidgetTourStepSide {
  TOP = "top",
  RIGHT = "right",
  BOTTOM = "bottom",
  LEFT = "left",
}

export enum WidgetTourStepAlign {
  START = "start",
  CENTER = "center",
  END = "end",
}

export interface WidgetTourStepBase {
  id?: string;
  type?: WidgetTourStepType;
  position?: number;
  // CSS selector the popover attaches to; when absent the step renders as a centered modal.
  element?: string | null;
  title?: string;
  description?: string;
  side?: WidgetTourStepSide;
  align?: WidgetTourStepAlign;
  page_path?: string;
}

export interface PostWidgetTourStep extends WidgetTourStepBase {
  type?: WidgetTourStepType.POST;
}

export interface PointerWidgetTourStep extends WidgetTourStepBase {
  type?: WidgetTourStepType.POINTER;
}

export interface VideoPointerWidgetTourStep extends WidgetTourStepBase {
  type?: WidgetTourStepType.VIDEO_POINTER;
  media_url?: string;
}

export type WidgetTourStep =
  | PostWidgetTourStep
  | PointerWidgetTourStep
  | VideoPointerWidgetTourStep;

export interface WidgetTour {
  id?: string;
  name?: string;
  enabled?: boolean;
  color?: string | null;
  background_color?: string | null;
  steps?: WidgetTourStep[];
  widget_id?: string;
  created_at?: string;
  author_id?: string;
  author?: Agent;
}

export type WidgetTourFilterProperty = keyof Pick<
  WidgetTour,
  "name" | "created_at"
>;

export const WidgetTourFilters: WidgetTourFilterProperty[] = ["name", "created_at"];

export type WidgetTourFilter = ResourceFilter<WidgetTourFilterProperty>;

export type WidgetTranslateableFields = {
  welcome_message?: string;
  start_conversation_button_text?: string;
  user_welcome_message?: string;
  special_notice_text?: string;
};

export interface Agent {
  id?: string;
  name?: string;
  email?: string;
  avatar_url?: string;
}

export interface Widget {
  id?: string;
  name?: string;
  enabled?: boolean;
  locale?: PublicLocale;
  supported_locales?: PublicLocale[];
  spaces?: WidgetSpace[];
  cards?: WidgetCard[];
  tours?: WidgetTour[];
  show_launcher?: boolean;
  action_color?: string;
  background_color?: string;
  allowed_domains?: string[];
  logo_light_url?: string;
  logo_light?: any;
  logo_dark_url?: string;
  logo_dark?: any;
  show_avatars?: boolean;
  header_height?: string | number;
  header_background_fade?: boolean;
  header_image_url?: string;
  header_image?: any;
  show_reply_expectation?: boolean;
  special_notice_enabled?: boolean;
  audio_enabled?: boolean;
  translations?: MobilityTranslations<WidgetTranslateableFields>;
  api_base_url?: string;
  script_url?: string;
  preview_url?: string;
  created_at?: string;
  version?: string;
  agents?: Agent[];
  help_center_id?: string;
  news_center_id?: string;
  outbound_messages?: WidgetOutboundMessage[];
}

export interface WidgetPing {}

export type WidgetProperty = keyof Widget;

export type WidgetColumnProperty = keyof Pick<
  Widget,
  "id" | "name" | "enabled"
>;
export const WidgetColumns: WidgetColumnProperty[] = [];

export type WidgetFilterProperty = keyof Pick<
  Widget,
  "name" | "enabled" | "created_at"
>;

export const WidgetFilters: WidgetFilterProperty[] = [
  "name",
  "enabled",
  "created_at",
];
export type WidgetFilter = ResourceFilter<WidgetFilterProperty>;

export interface WidgetSessionUserData {
  id?: string;
  name?: string;
  email?: string;
  locale?: PublicLocale;
  location?: string;
  last_seen_at?: string;
  created_at?: string;
}

export interface WidgetSession {
  id?: string;
  session_id?: string;
  anonymous_id?: string;
  widget_id?: string;
  user_data?: WidgetSessionUserData;
}

export interface Conversation {
  id?: string;
  state?: ConversationState;
  source?: ConversationSource;
  priority?: boolean;
  admin_read?: boolean;
  user_read?: boolean;
  user_data?: WidgetSessionUserData;
  messages?: ConversationMessage[];
  assignee?: User;
  assignee_id?: string | null;
  session_id?: string;
  created_at?: string | Date;
}

export enum ConversationSource {
  // i18n.t('ConversationSource::user')
  USER = "user",
  // i18n.t('ConversationSource::admin')
  ADMIN = "admin",
  // i18n.t('ConversationSource::outbound_message')
  OUTBOUND_MESSAGE = "outbound_message",
}

export enum ConversationState {
  // i18n.t('ConversationState::open')
  OPEN = "open",
  // i18n.t('ConversationState::closed')
  CLOSED = "closed",
  // i18n.t('ConversationState::snoozed')
  SNOOZED = "snoozed",
}

export enum ConversationMessageType {
  // i18n.t(`ConversationMessageType::request_email`)
  REQUEST_EMAIL = "request_email",
  // i18n.t(`ConversationMessageType::text`)
  TEXT = "text",
  // i18n.t(`ConversationMessageType::note`)
  NOTE = "note",
  // i18n.t(`ConversationMessageType::attachment`)
  ATTACHMENT = "attachment",
  // i18n.t(`ConversationMessageType::gif`)
  GIF = "gif",
  // i18n.t(`ConversationMessageType::typing`)
  TYPING = "typing",
  // i18n.t(`ConversationMessageType::article`)
  ARTICLE = "article",
}

export enum ConversationMessageAuthorType {
  USER = "User",
  CONTACT = "Contact",
}
export interface ConversationMessageAuthor {
  name?: string;
  type?: ConversationMessageAuthorType;
  first_name?: string;
  initial?: string;
  avatar?: {
    url?: string;
  };
}

export interface ConversationMessageBase {
  id?: string;
  type: ConversationMessageType;
  client_assigned_id?: string;
  conversation_id?: string;
  created_at?: string | Date;
  author?: ConversationMessageAuthor;
}

export interface ConversationMessageRequestEmail
  extends ConversationMessageBase {
  type: ConversationMessageType.REQUEST_EMAIL;
  email?: string;
}

export interface ConversationMessageText extends ConversationMessageBase {
  type: ConversationMessageType.TEXT;
  content: string;
}

export interface ConversationMessageNote extends ConversationMessageBase {
  type: ConversationMessageType.NOTE;
  content: string;
}

export interface ConversationMessageAttachment extends ConversationMessageBase {
  type: ConversationMessageType.ATTACHMENT;
  attachment?: ActiveStorage.Blob | any;
  attachment_file_name?: string;
  attachment_content_type?: string;
  attachment_file_size?: number;
  attachment_url?: string | null;
  attachment_download_url?: string | null;
}

export interface ConversationMessageGif extends ConversationMessageBase {
  type: ConversationMessageType.GIF;
  url?: string | null;
}

export interface ConversationMessageTyping extends ConversationMessageBase {
  type: ConversationMessageType.TYPING;
}

export interface ConversationMessageArticle extends ConversationMessageBase {
  type: ConversationMessageType.ARTICLE;
  help_center_id: string;
  locale: PublicLocale;
  article_id: string;
}

export type ConversationMessage =
  | ConversationMessageRequestEmail
  | ConversationMessageText
  | ConversationMessageNote
  | ConversationMessageAttachment
  | ConversationMessageGif
  | ConversationMessageTyping
  | ConversationMessageArticle;

export interface TenorGif {
  id?: string;
  media_formats?: {
    gif?: {
      url?: string;
      dims?: number[];
      size?: string;
    };
  };
}

export enum ConversationChannelEventType {
  CONVERSATION_CREATE = "CONVERSATION_CREATE",
  CONVERSATION_UPDATE = "CONVERSATION_UPDATE",
  CONVERSATION_DELETE = "CONVERSATION_DELETE",
  ADMIN_TYPING = "ADMIN_TYPING",
  USER_TYPING = "USER_TYPING",
}

export interface ConversationChannelEventBase {
  type: ConversationChannelEventType;
  data: object;
}

export interface ConversationChannelCreateConversationEvent
  extends ConversationChannelEventBase {
  type: ConversationChannelEventType.CONVERSATION_CREATE;
  data: { conversation: Conversation };
}

export interface ConversationChannelUpdateConversationEvent
  extends ConversationChannelEventBase {
  type: ConversationChannelEventType.CONVERSATION_UPDATE;
  data: { conversation: Conversation };
}

export interface ConversationChannelDeleteConversationEvent
  extends ConversationChannelEventBase {
  type: ConversationChannelEventType.CONVERSATION_DELETE;
  data: { conversation_id: string };
}

export interface ConversationChannelAdminTypingEvent
  extends ConversationChannelEventBase {
  type: ConversationChannelEventType.ADMIN_TYPING;
  data: { typing: boolean };
}

export interface ConversationChannelUserTypingEvent
  extends ConversationChannelEventBase {
  type: ConversationChannelEventType.USER_TYPING;
  data: { typing: boolean };
}

export type ConversationChannelEvent =
  | ConversationChannelCreateConversationEvent
  | ConversationChannelUpdateConversationEvent
  | ConversationChannelDeleteConversationEvent
  | ConversationChannelAdminTypingEvent
  | ConversationChannelUserTypingEvent;

export enum WidgetSessionChannelEventType {
  CONVERSATION_CREATE = "CONVERSATION_CREATE",
  CONVERSATION_UPDATE = "CONVERSATION_UPDATE",
  CONVERSATION_DELETE = "CONVERSATION_DELETE",
}

export interface WidgetSessionChannelEventBase {
  type: WidgetSessionChannelEventType;
  data: object;
}
export interface WidgetSessionChannelCreateConversationEvent
  extends WidgetSessionChannelEventBase {
  type: WidgetSessionChannelEventType.CONVERSATION_CREATE;
  data: { conversation: Conversation };
}

export interface WidgetSessionChannelUpdateConversationEvent
  extends WidgetSessionChannelEventBase {
  type: WidgetSessionChannelEventType.CONVERSATION_UPDATE;
  data: { conversation: Conversation };
}

export interface WidgetSessionChannelDeleteConversationEvent
  extends WidgetSessionChannelEventBase {
  type: WidgetSessionChannelEventType.CONVERSATION_DELETE;
  data: { conversation_id: string };
}

export type WidgetSessionChannelEvent =
  | WidgetSessionChannelCreateConversationEvent
  | WidgetSessionChannelUpdateConversationEvent
  | WidgetSessionChannelDeleteConversationEvent;

export enum Sounds {
  COMPLETE = "complete.mp3",
  STEP_COMPLETE = "step-complete.mp3",
  NOTIFICATION = "notification.mp3",
  NOTIFICATION_ADMIN = "notification-admin.mp3",
  OPERATOR = "operator.mp3",
  SUBMIT = "submit.mp3",
  BOP = "bop.mp3",
}

export interface WidgetCounters {
  unread_conversations: number;
}

export interface MessageFormField {
  identifier: string;
  value: string;
  message_id: string;
}

export enum HelpCenterMessengerEventType {
  // When the widget is initialized
  DEEP_LINK = "DEEP_LINK",
  // Article loaded
  ARTICLE_LOADED = "ARTICLE_LOADED",
}

export interface HelpCenterMessengerEventBase {
  type: HelpCenterMessengerEventType;
}

export interface HelpCenterMessengerDeepLinkEvent
  extends HelpCenterMessengerEventBase {
  type: HelpCenterMessengerEventType.DEEP_LINK;
  url: string;
}

export interface HelpCenterMessengerArticleLoadedEvent
  extends HelpCenterMessengerEventBase {
  type: HelpCenterMessengerEventType.ARTICLE_LOADED;
}

export type HelpCenterMessengerEvent =
  | HelpCenterMessengerDeepLinkEvent
  | HelpCenterMessengerArticleLoadedEvent;

export interface NewsCenterLink {
  locale: PublicLocale;
  label: string;
  url: string;
}

export interface NewsCenter {
  id?: string;
  name?: string;
  business_name?: string;
  enabled?: boolean;
  locale?: string;
  url?: string;
  supported_locales?: PublicLocale[];
  slug?: string;
  custom_domain?: string;
  google_analytics_id?: string;
  favicon?: any;
  favicon_url?: string;
  open_graph_image?: any;
  open_graph_image_url?: string;
  background_color?: string;
  action_color?: string;
  show_news_authors?: boolean;
  logo_url?: string;
  logo?: any;
  header_page_title?: string;
  header_links?: NewsCenterLink[];
  header_background_color?: string;
  header_text_color?: string;
  header_background_fade?: boolean;
  header_height?: string | number;
  header_image?: any;
  header_image_url?: string;
  table_of_contents_enabled?: boolean;
  translations?: MobilityTranslations<NewsCenterTranslateableFields>;
  created_at?: string;
}

export type NewsCenterProperty = keyof NewsCenter;

export type NewsCenterColumnProperty = keyof Pick<NewsCenter, "id" | "name">;
export const NewsCenterColumns: NewsCenterColumnProperty[] = [];

export type NewsCenterFilterProperty = keyof Pick<
  NewsCenter,
  "name" | "enabled" | "created_at"
>;

export const NewsCenterFilters: NewsCenterFilterProperty[] = [
  "name",
  "enabled",
  "created_at",
];
export type NewsCenterFilter = ResourceFilter<NewsCenterFilterProperty>;

export type NewsCenterTranslateableFields = {
  title?: string;
  description?: string;
  welcome_message?: string;
  featured_articles_title?: string;
};

export type NewsTranslateableFields = {
  title?: string;
  slug?: string;
  summary?: string;
  content?: string;
};

export interface NewsTag {
  id?: string;
  name?: string;
}

export interface News {
  id?: string;
  author_id?: string;
  author?: Author;
  position?: number;
  translations?: MobilityTranslations<NewsTranslateableFields>;
  tags?: NewsTag[];
  tag_ids?: string[];
  cover_image_url?: string;
  updated_at?: string;
  created_at?: string;
}

export enum NewsCenterMessengerEventType {
  // When the widget is initialized
  DEEP_LINK = "DEEP_LINK",
  // News loaded
  NEWS_LOADED = "NEWS_LOADED",
}

export interface NewsCenterMessengerEventBase {
  type: NewsCenterMessengerEventType;
}

export interface NewsCenterMessengerDeepLinkEvent
  extends NewsCenterMessengerEventBase {
  type: NewsCenterMessengerEventType.DEEP_LINK;
  url: string;
}

export interface NewsCenterMessengerArticleLoadedEvent
  extends NewsCenterMessengerEventBase {
  type: NewsCenterMessengerEventType.NEWS_LOADED;
}

export type NewsCenterMessengerEvent =
  | NewsCenterMessengerDeepLinkEvent
  | NewsCenterMessengerArticleLoadedEvent;

export enum NewsCenterTreeModelType {
  NEWS = "news",
  ADD_NEWS = "add_news",
}
export interface NewsCenterTreeDataBase {
  type: NewsCenterTreeModelType;
  children?: HelpCenterTreeData[];
}

export interface NewsCenterTreeDataNews extends NewsCenterTreeDataBase {
  type: NewsCenterTreeModelType.NEWS;
  model: News;
}

export interface NewsCenterTreeDataAddNews extends NewsCenterTreeDataBase {
  type: NewsCenterTreeModelType.ADD_NEWS;
  model: any;
}

export type NewsCenterTreeData =
  | NewsCenterTreeDataNews
  | NewsCenterTreeDataAddNews;

export enum NewsCenterPage {
  // i18n.t('NewsCenterPage::homepage')
  HOMEPAGE = "homepage",
  // i18n.t('NewsCenterPage::news')
  NEWS = "news",
}

export interface NewsCenterTheme {
  colors: {
    body: string;
    action: string;
  };
}

export enum IncomingSelfBillingOrderType {
  // i18n.t('IncomingSelfBillingOrderType::invoice')
  INVOICE = "invoice",
  // i18n.t('IncomingSelfBillingOrderType::credit_note')
  CREDIT_NOTE = "credit_note",
}

export interface IncomingSelfBillingOrder {
  // i18n.t('IncomingSelfBillingOrder::id')
  id?: string;
  // i18n.t('IncomingSelfBillingOrder::type')
  type?: IncomingSelfBillingOrderType;
  // i18n.t('IncomingSelfBillingOrder::number')
  number?: string;
  // i18n.t('IncomingSelfBillingOrder::issue_date')
  issue_date?: string | Date;
  // i18n.t('IncomingSelfBillingOrder::due_date')
  due_date?: string | Date;
  // i18n.t('IncomingSelfBillingOrder::paid_on')
  paid_on?: string | Date;
  // i18n.t('IncomingSelfBillingOrder::booked_on')
  booked_on?: string | Date;
  // i18n.t('IncomingSelfBillingOrder::currency')
  currency?: string;
  // i18n.t('IncomingSelfBillingOrder::net_total')
  net_total?: string | number;
  // i18n.t('IncomingSelfBillingOrder::amount')
  amount?: string | number;
  // i18n.t('IncomingSelfBillingOrder::remittance_information')
  remittance_information?: string;
  // i18n.t('IncomingSelfBillingOrder::remittance_information_type')
  remittance_information_type?: RemittanceInformationType;
  // i18n.t('IncomingSelfBillingOrder::attachment_file_name')
  attachment_file_name?: string;
  // i18n.t('IncomingSelfBillingOrder::attachment_content_type')
  attachment_content_type?: string;
  // i18n.t('IncomingSelfBillingOrder::attachment_file_size')
  attachment_file_size?: number;
  // i18n.t('IncomingSelfBillingOrder::attachment_url')
  attachment_url?: string | null;
  // i18n.t('IncomingSelfBillingOrder::attachment_download_url')
  attachment_download_url?: string | null;
  // i18n.t('IncomingSelfBillingOrder::created_at')
  created_at?: string;
  // i18n.t('IncomingSelfBillingOrder::updated_at')
  updated_at?: string;
  // i18n.t('IncomingSelfBillingOrder::contact_id')
  contact_id?: string;
  // i18n.t('IncomingSelfBillingOrder::contact')
  // i18n.t('IncomingSelfBillingOrder::client')
  contact?: Contact;
}

export type IncomingSelfBillingOrderProperty = keyof IncomingSelfBillingOrder;

export type IncomingSelfBillingOrderColumnProperty = keyof Pick<
  IncomingSelfBillingOrder,
  | "id"
  | "type"
  | "number"
  | "contact"
  | "issue_date"
  | "due_date"
  | "paid_on"
  | "booked_on"
  | "currency"
  | "net_total"
  | "amount"
  | "remittance_information"
  | "created_at"
  | "updated_at"
>;
export const IncomingSelfBillingOrderColumns: IncomingSelfBillingOrderColumnProperty[] =
  [
    "id",
    "type",
    "number",
    "contact",
    "issue_date",
    "due_date",
    "paid_on",
    "booked_on",
    "currency",
    "net_total",
    "amount",
    "remittance_information",
    "created_at",
    "updated_at",
  ];

export type IncomingSelfBillingOrderFilterProperty = keyof Pick<
  IncomingSelfBillingOrder,
  | "number"
  | "issue_date"
  | "due_date"
  | "paid_on"
  | "booked_on"
  | "currency"
  | "net_total"
  | "remittance_information"
  | "amount"
  | "contact_id"
  | "created_at"
>;

export const IncomingSelfBillingOrderFilters: IncomingSelfBillingOrderFilterProperty[] =
  [
    "number",
    "issue_date",
    "due_date",
    "paid_on",
    "currency",
    "net_total",
    "remittance_information",
    "amount",
    "contact_id",
    "created_at",
  ];
export type IncomingSelfBillingOrderFilter =
  ResourceFilter<IncomingSelfBillingOrderFilterProperty>;

export enum IncomingSelfBillingOrderExportType {
  // i18n.t('IncomingSelfBillingOrderExportType::xlsx')
  EXCEL = "xlsx",
  // i18n.t('IncomingSelfBillingOrderExportType::csv')
  CSV = "csv",
  // i18n.t('IncomingSelfBillingOrderExportType::ubl')
  UBL = "ubl",
}

export interface ExportIncomingSelfBillingOrderParams {
  type: IncomingSelfBillingOrderExportType;
  start: string;
  end: string;
}

export enum IncomingSelfBillingOrderStatus {
  // t('IncomingSelfBillingOrderStatus::outstanding')
  OUTSTANDING = "outstanding",
  // t('IncomingSelfBillingOrderStatus::paid')
  PAID = "paid",
  // t('IncomingSelfBillingOrderStatus::overdue')
  OVERDUE = "overdue",
  // t('IncomingSelfBillingOrderStatus::credited')
  CREDITED = "credited",
}

export interface ResourceRendererResult<T, P> {
  headers: ResourceTableHeader[];
  columns: { label: string; value: string }[];
  selectedColumns: P[];
  renderRow: (item: T, index: number) => React.ReactElement;
}

export interface TaskRendererResult
  extends ResourceRendererResult<Task, TaskProperty> {
  renderHeader: () => React.ReactElement;
}

export interface ResourceRendererOptions<T> {
  setting: Settings;
  onRowClick?: (item: T) => void;
  selectedItems?: string[];
  onSelectionChange?: (selected: boolean, id: string) => void;
  onActionClick?: (key: string, item: T) => void;
}

export interface RecurringInvoiceRendererOptions
  extends ResourceRendererOptions<LedgerItem> {
  onAutoSendToggle: (e, ledgerItem: LedgerItem) => void;
}

export interface TaskRenderOptions extends ResourceRendererOptions<Task> {
  onSortChange: (sortValue: string) => void;
  sortValue: string;
  onCompletedChange: (task: Task) => void;
}

export interface ResourceColumnConfig {
  header: (options: any) => ResourceTableHeader;
}

export interface ProjectColumnConfig extends ResourceColumnConfig {
  render: (options: { project: Project; setting: Settings }) => React.ReactNode;
}

export interface DealColumnConfig extends ResourceColumnConfig {
  render: (options: { deal: Deal; setting: Settings }) => React.ReactNode;
}

export interface SequenceColumnConfig extends ResourceColumnConfig {
  render: (options: {
    sequence: Sequence;
    setting: Settings;
    onActiveToggle?: (
      e: React.ChangeEvent<HTMLInputElement>,
      sequence: Sequence,
    ) => void;
    onBusinessDayToggle?: (
      e: React.ChangeEvent<HTMLInputElement>,
      sequence: Sequence,
    ) => void;
  }) => React.ReactNode;
}

export interface ExpenseColumnConfig extends ResourceColumnConfig {
  render: (options: { expense: Expense; setting: Settings }) => React.ReactNode;
}

export interface ProductColumnConfig extends ResourceColumnConfig {
  render: (options: { product: Product; setting: Settings }) => React.ReactNode;
}

export interface LedgerItemColumnConfig extends ResourceColumnConfig {
  render: (options: {
    ledgerItem: LedgerItem;
    setting: Settings;
  }) => React.ReactNode;
}

export interface RecurringInvoiceColumnConfig extends ResourceColumnConfig {
  render: (options: {
    ledgerItem: LedgerItem;
    setting: Settings;
    onAutoSendToggle?: (
      e: React.ChangeEvent<HTMLInputElement>,
      ledgerItem: LedgerItem,
    ) => void;
  }) => React.ReactNode;
}

export interface IncomingSelfBillingOrderColumnConfig
  extends ResourceColumnConfig {
  render: (options: {
    selfBillingOrder: IncomingSelfBillingOrder;
    setting: Settings;
  }) => React.ReactNode;
}

export enum WidgetOutboundMessageType {
  // i18n.t('WidgetOutboundMessageType::chat')
  CHAT = "chat",
  // i18n.t('WidgetOutboundMessageType::banner')
  BANNER = "banner",
}

export enum WidgetOutboundPredicateAttribute {
  // i18n.t('WidgetOutboundPredicateAttribute::current_url')
  CURRENT_URL = "current_url",
  // i18n.t('WidgetOutboundPredicateAttribute::time_on_page')
  TIME_ON_PAGE = "time_on_page",
  // i18n.t('WidgetOutboundPredicateAttribute::locale')
  LOCALE = "locale",
}

export enum WidgetOutboundPredicateType {
  STRING = "string",
  DURATION_INTEGER = "duration_integer",
}

export enum WidgetOutboundPredicateComparison {
  // i18n.t('WidgetOutboundPredicateComparison::contains')
  CONTAINS = "contains",
  // i18n.t('WidgetOutboundPredicateComparison::does_not_contain')
  DOES_NOT_CONTAIN = "does_not_contain",
  // i18n.t('WidgetOutboundPredicateComparison::is')
  IS = "is",
  // i18n.t('WidgetOutboundPredicateComparison::is_not')
  IS_NOT = "is_not",
  // i18n.t('WidgetOutboundPredicateComparison::starts_with')
  STARTS_WITH = "starts_with",
  // i18n.t('WidgetOutboundPredicateComparison::ends_with')
  ENDS_WITH = "ends_with",
  // i18n.t('WidgetOutboundPredicateComparison::eq')
  EQ = "eq",
  // i18n.t('WidgetOutboundPredicateComparison::gt')
  GT = "gt",
  // i18n.t('WidgetOutboundPredicateComparison::lt')
  LT = "lt",
  // i18n.t('WidgetOutboundPredicateComparison::gte')
  GTE = "gte",
  // i18n.t('WidgetOutboundPredicateComparison::lte')
  LTE = "lte",
}

export enum WidgetOutboundPredicateGroupType {
  OR = "or",
  AND = "and",
}

export interface WidgetOutboundPredicate {
  attribute: WidgetOutboundPredicateAttribute;
  type: WidgetOutboundPredicateType;
  comparison: WidgetOutboundPredicateComparison;
  value: string;
}

export interface WidgetOutboundPredicateGroup {
  type: WidgetOutboundPredicateGroupType;
  predicates: WidgetOutboundPredicate[];
}

export interface WidgetOutboundRegularPredicateGroup {
  predicates: WidgetOutboundPredicateGroup[];
}

export interface WidgetOutboundClientPredicateGroup {
  predicates: WidgetOutboundPredicateGroup[];
}

export type WidgetOutboundMessageTranslateableFields = {
  message?: string;
};

export interface WidgetOutboundMessage {
  id?: string;
  name?: string;
  type: WidgetOutboundMessageType;
  translations?: MobilityTranslations<WidgetOutboundMessageTranslateableFields>;
  predicate_group?: WidgetOutboundRegularPredicateGroup;
  client_predicate_group?: WidgetOutboundClientPredicateGroup;
  author_id?: string;
  author?: Agent;
  assignee_id?: string;
  assignee?: Agent;
  widget_id?: string;
  created_at?: string;
  updated_at?: string;
}

export type WidgetOutboundMessageFilterProperty = keyof Pick<
  WidgetOutboundMessage,
  "name" | "type" | "created_at"
>;

export const WidgetOutboundMessageFilters: WidgetOutboundMessageFilterProperty[] =
  ["name", "type", "created_at"];

export type WidgetOutboundMessageFilter =
  ResourceFilter<WidgetOutboundMessageFilterProperty>;

export enum EventTypeLocationType {
  GOOGLE_MEET = 'google_meet',
  MICROSOFT_TEAMS = 'microsoft_teams',
  IN_PERSON_ORGANIZER = 'in_person_organizer',
  IN_PERSON_ATTENDEE = 'in_person_attendee',
  PHONE_ORGANIZER = 'phone_organizer',
  PHONE_ATTENDEE = 'phone_attendee',
}

export interface EventTypeLocation {
  type: EventTypeLocationType
  // Organizer address/phone; on public event types only present when display_on_booking_page is set
  value: string | null
  display_on_booking_page: boolean
}

export enum EventTypePeriodType {
  UNLIMITED = 'unlimited',
  ROLLING = 'rolling',
  RANGE = 'range',
}

export type SchedulingLimitPeriod = 'day' | 'week' | 'month' | 'year'
export type SchedulingLimit = Partial<Record<SchedulingLimitPeriod, number | null>>

export interface SchedulingHost {
  id: string
  name: string
  avatar_url?: string | null
}

export interface EventType {
  id?: string
  title: string
  slug: string
  description: string
  duration: number
  active: boolean
  position?: number
  durations: number[]
  locations: EventTypeLocation[]
  before_event_buffer: number
  after_event_buffer: number
  minimum_booking_notice: number
  minimum_booking_notice_unit: 'minutes' | 'hours' | 'days'
  slot_interval: number | null
  booking_frequency_limit: SchedulingLimit
  booking_duration_limit: SchedulingLimit
  period_type: EventTypePeriodType
  period_days: number
  period_count_calendar_days: boolean
  period_start_date: string | null
  period_end_date: string | null
  max_active_bookings_per_booker: number | null
  only_first_slot_per_day: boolean
  user_id?: string
  host?: SchedulingHost
  booking_slug?: string | null
  public_url?: string | null
  preview_url?: string | null
  timezone?: string
  week_schedule?: WeekdaySchedule[]
  connected_calendar_types?: string[]
  created_at?: string
  updated_at?: string
}

export type EventTypeProperty = keyof EventType

export type EventTypeColumnProperty = keyof Pick<
  EventType,
  'title' | 'durations' | 'locations' | 'active' | 'host' | 'created_at'
>

export const EventTypeColumns: EventTypeColumnProperty[] = [
  'title',
  'host',
  'durations',
  'locations',
  'active',
  'created_at',
]

export interface EventTypeColumnConfig extends ResourceColumnConfig {
  header: () => ResourceTableHeader
  render: (options: { eventType: EventType; setting: Settings }) => React.ReactNode
}

export type EventTypeFilterProperty = keyof Pick<EventType, 'title' | 'user_id' | 'active' | 'created_at'>

export const EventTypeFilters: EventTypeFilterProperty[] = [
  'title',
  'user_id',
  'active',
  'created_at',
]
export type EventTypeFilter = ResourceFilter<EventTypeFilterProperty>

export interface PublicEventType {
  id: string
  title: string
  slug: string
  description: string
  duration: number
  durations: number[]
  locations: EventTypeLocation[]
  host: SchedulingHost
  booking_slug: string
}

export interface PublicBooking {
  uid: string
  title: string
  start_time: string
  end_time: string
  booker_name: string
  booker_email: string
  booker_timezone: string
  guests: string[]
  location: EventTypeLocationType | null
  location_value: string | null
  meeting_link: string | null
  host: { name: string, avatar_url?: string | null }
  event_type: { title: string, duration: number }
}

export interface Booking {
  id: string
  uid: string
  status: string
  title: string
  start_time: string
  end_time: string
  booker_name: string
  booker_email: string
  booker_timezone: string
  guests: string[]
  location: EventTypeLocationType | null
  location_value: string | null
  meeting_link: string | null
  contact_id: string | null
  calendar_event_id: string | null
  host: { id: string, name: string, avatar_url?: string | null }
  event_type: { id: string, title: string, duration: number }
  created_at: string
}

export type BookingProperty = keyof Booking

export type BookingColumnProperty = keyof Pick<
  Booking,
  'start_time' | 'booker_name' | 'event_type' | 'host' | 'location' | 'guests' | 'created_at'
>

export const BookingColumns: BookingColumnProperty[] = [
  'start_time',
  'booker_name',
  'event_type',
  'host',
  'location',
  'guests',
  'created_at',
]

export interface BookingColumnConfig extends ResourceColumnConfig {
  header: () => ResourceTableHeader
  render: (options: { booking: Booking; setting: Settings }) => React.ReactNode
}

export enum BookingPeriod {
  UPCOMING = 'upcoming',
  PAST = 'past',
}

export enum BookingStatus {
  ACCEPTED = 'accepted',
}

export type BookingFilterProperty =
  | 'period'
  | 'event_type_id'
  | 'host_id'
  | 'status'
  | 'booker_name'
  | 'booker_email'
  | 'contact_id'
  | 'location'
  | 'guests'
  | 'start_time'
  | 'created_at'

export type BookingFilter = ResourceFilter<BookingFilterProperty>

export interface SlotsResponse {
  slots: Record<string, string[]>
}
